<template>
<div>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <SideBar />
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-muted mb-0 hover-cursor link" @click="toPage('/resolution')">&nbsp;Resolution Center</p>
          <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;Detail</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div v-if="cancelResolution && (ticketPurpose == 'Kendala' && ticketStatus < 4 || ticketPurpose !== 'Kendala' && (ticketStatus == 0 || ticketStatus == 3) )" >
      <!-- <div class="container-fluid" v-if="ticketStatus < 4 && this.ticketPurpose == 'Kendala' && this.cancelResolution" > -->
      <div class="container-fluid" v-if="ticketStatus < 4" >
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <div class="row">
                <div class="col-md-12 grid-margin stretch-card card-div">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12">
                      <div class="row">
                        <div :class="ticketActionBoxTheme">
                          <div class="row ticket-action-box">
                            <div class="col-12 mb-1 mt-1">
                              <div class="container mt-4 mb-4">
                                <div class="row">
                                  <div class="col-lg-7 col-sm-12">
                                      <div class="row">
                                        <div class="col-lg-1 col-sm-1">
                                          <img src="@/assets/icon/check-icon-blue.png" style="width: 28px;" v-if="ticketStatus == 0"/>
                                          <img src="@/assets/icon/cancel-icon-red.png" style="width: 28px;" v-if="ticketStatus > 0 && ticketStatus < 3 && ticketPurpose == 'Kendala' && cancelResolution"/>
                                          <img src="@/assets/icon/reopen-icon-yellow.png" style="width: 28px;" v-if="ticketStatus == 3"/>
                                        </div>
                                        <div class="col-lg-11 col-sm-11">
                                           <h5> {{ticketActionBoxText.title}} </h5>
                                            <div class="mt-7">{{ticketActionBoxText.description}}</div>
                                        </div>
                                      </div>
                                  </div>
                                  <div class="col-lg-5 col-sm-12" :style="{margin: 'auto'}">
                                    
                                    <!-- Confirm Action -->
                                    <button class="btn btn-primary btn-sm float-right shadow-sm ml-1 pt-2 pb-2 pr-3 pl-3" @click="openModal('Confirm')" v-if="ticketStatus == 0"> Confirm Ticket </button>
                                    <button class="btn btn-outline-danger float-right shadow-sm btn-sm pt-2 pb-2 pr-3 pl-3" :style="{'margin-right' : 10 +'px'}" @click="openModal('Cancel')" v-if="ticketStatus == 0 && ticketPurpose == 'Kendala' && cancelResolution"> Cancel Ticket </button>
                                    <!-- Cancel Action -->
                                    <button class="btn btn-danger float-right shadow-sm btn-sm ml-1 pt-2 pb-2 pr-3 pl-3" :style="{'margin-right' : 10 +'px'}" @click="openModal('Cancel')" v-if="ticketStatus > 0 && ticketStatus < 3 && ticketPurpose == 'Kendala' && cancelResolution"> Cancel Ticket </button>
                                    <!-- Reopen Action -->
                                    <button class="btn btn-warning float-right shadow-sm btn-sm ml-1 pt-2 pb-2 pr-3 pl-3" @click="openModal('ReopenCase')" v-if="ticketStatus == 3"> Reopen Case </button>                               
                                  </div>
                                </div>
                                
                              </div>
                            </div>
                          </div>
                      
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div v-else-if="!cancelResolution && (ticketPurpose == 'Kendala' && ticketStatus < 4 || ticketPurpose !== 'Kendala' && (ticketStatus == 0 || ticketStatus == 3) )" >
        <!-- <div class="container-fluid" v-if="ticketStatus < 4 && this.ticketPurpose == 'Kendala' && this.cancelResolution" > -->
        <div class="container-fluid" v-if="(ticketStatus == 0 || ticketStatus == 3)" >
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <div class="row">
                  <div class="col-md-12 grid-margin stretch-card card-div">
                    <div class="row">
                      <div class="col-lg-12 col-sm-12">
                        <div class="row">
                          <div :class="ticketActionBoxTheme">
                            <div class="row ticket-action-box">
                              <div class="col-12 mb-1 mt-1">
                                <div class="container mt-4 mb-4">
                                  <div class="row">
                                    <div class="col-lg-7 col-sm-12">
                                        <div class="row">
                                          <div class="col-lg-1 col-sm-1">
                                            <img src="@/assets/icon/check-icon-blue.png" style="width: 28px;" v-if="ticketStatus == 0"/>
                                            <img src="@/assets/icon/cancel-icon-red.png" style="width: 28px;" v-if="ticketStatus > 0 && ticketStatus < 3 && ticketPurpose == 'Kendala' && cancelResolution"/>
                                            <img src="@/assets/icon/reopen-icon-yellow.png" style="width: 28px;" v-if="ticketStatus == 3"/>
                                          </div>
                                          <div class="col-lg-11 col-sm-11">
                                            <h5> {{ticketActionBoxText.title}} </h5>
                                              <div class="mt-7">{{ticketActionBoxText.description}}</div>
                                          </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-sm-12" :style="{margin: 'auto'}">
                                      
                                      <!-- Confirm Action -->
                                      <button class="btn btn-primary btn-sm float-right shadow-sm ml-1 pt-2 pb-2 pr-3 pl-3" @click="openModal('Confirm')" v-if="ticketStatus == 0"> Confirm Ticket </button>
                                      <button class="btn btn-outline-danger float-right shadow-sm btn-sm pt-2 pb-2 pr-3 pl-3" :style="{'margin-right' : 10 +'px'}" @click="openModal('Cancel')" v-if="ticketStatus == 0 && ticketPurpose == 'Kendala' && cancelResolution"> Cancel Ticket </button>
                                      <!-- Cancel Action -->
                                      <button class="btn btn-danger float-right shadow-sm btn-sm ml-1 pt-2 pb-2 pr-3 pl-3" :style="{'margin-right' : 10 +'px'}" @click="openModal('Cancel')" v-if="ticketStatus > 0 && ticketStatus < 3 && ticketPurpose == 'Kendala' && cancelResolution"> Cancel Ticket </button>
                                      <!-- Reopen Action -->
                                      <button class="btn btn-warning float-right shadow-sm btn-sm ml-1 pt-2 pb-2 pr-3 pl-3" @click="openModal('ReopenCase')" v-if="ticketStatus == 3"> Reopen Case </button>                               
                                    </div>
                                  </div>
                                  
                                </div>
                              </div>
                            </div>
                        
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <div class="row">
                <div class="col-md-12 grid-margin stretch-card card-div">
                  <div class="row">
                    <div class="col-lg-5 col-sm-12">
                      <div class="row" style="height : 100%">
                        <div class="col-12 border shadow-sm rounded">
                          <div class="row border-bottom title-square-background rounded-top">
                            <div class="col-12 d-flex justify-content-between mb-1 mt-1">
                              <div class="title-square"> 
                                <img src="~@/assets/icon/headphone.png" alt='Informasi Tiket' width='15px' height='15px' style='margin-bottom : 4px'/>
                                {{'Informasi Tiket & Perbaikan'}} 
                                </div>
                              <button class="btn btn-light btn-sm" style="color: #409cff" @click="openModal('RepairInfo')" v-if="ticketStatus == 2"><i style='font-size:18px' class='fas'>&#xf044;</i> Edit</button>
                              <!-- <button class="btn btn-light btn-sm" @click="openModal('TicketInfo')" v-if="ticketStatus != 4 && ticketStatus != 3 && ticketStatus != null"><i style='font-size:18px' class='fas'>&#xf044;</i> Edit</button> -->
                            </div>
                          </div>
                          <table class="mb-2 mt-2 ticket-info-table">
                            <!-- <tr>
                              <td valign="top">Company Name</td>
                              <td valign="top">&emsp;:&emsp;</td>
                              <td>{{companyName}}</td>
                            </tr> -->
                            <tr style="height:30px">
                              <td>Ticket number</td>
                              <td>:</td>
                              <td>{{ticketNumber}}</td>
                            </tr>
                            <tr style="height:30px">
                              <td>Ticket status</td>
                              <td>:</td>
                              <td>
                                <span
                                  class="status-badge"
                                  v-if="ticketStatusBadge"
                                  :style="'background-color:'+ticketStatusBadge.bgColor +'; color:'+ticketStatusBadge.textColor+';'"
                                >{{ ticketStatusBadge.text }}</span>
                              </td>
                            </tr>
                            <tr style="height:30px">
                              <td>Technician</td>
                              <td>:</td>
                              <td>{{asaniTechnicianName ? asaniTechnicianName : '-'}}</td>
                            </tr>
                            <tr style="height:30px">
                              <td>Repair schedule</td>
                              <td>:</td>
                              <td>
                                {{repairSchedule ? repairSchedule : 'Not Scheduled'}}
                                <span v-if="repairSchedule && repairType !== null"> ({{getRepairName(repairType)}})</span>
                              </td>
                            </tr>
                            </table>
                          <div class="mb-2">
                            <span
                              class="item-badge"
                              v-if="ticketPurpose"
                              :style="'background-color:'+ticketPurposeTheme.bgColor +'; border-color:'+ticketPurposeTheme.borderColor+';'"
                            >
                              <img src="@/assets/icon/icon-kendala.png" style="width: 12px;" class='ml-1 mr-1' v-if="ticketPurpose == 'Kendala'"/>
                              <img src="@/assets/icon/icon-upgrade.png" style="width: 8px;" class='ml-1 mr-1' v-if="ticketPurpose == 'Upgrade'"/>
                              Category: {{ ticketPurpose }}
                            </span>
                          </div>
                          <div class="d-flex flex-wrap mb-2" style="gap: 8px;">
                            <button
                            class="btn btn-outline-primary btn-sm"
                            @click="downloadBast()"
                            v-if="ticketBastInfo && !loadingDownloadTicketBast"
                            >
                              <img src="@/assets/icon/download.png" style="width: 16px;" class='ml-1 mr-1 mb-1'/>
                              <b>Lihat BAST</b>
                            </button>
                            <button
                              type="button"
                              class="btn btn-primary btn-sm"
                              disabled
                              v-else-if="ticketBastInfo"
                            >
                              <img src="@/assets/icon/download.png" style="width: 16px;" class='ml-1 mr-1 mb-1'/>
                              <b>Lihat BAST</b>
                              <img src="~@/assets/images/2.gif" style="height: 18px;">
                            </button>
                            <template v-if="ticketStatus === 3 || ticketStatus === 4">
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                @click="openModalDar()"
                                v-if="!hasFinalDarDocument && (allowCreateDarDoc && allowViewDarDoc)"
                              >
                                <i class="fas fa-file-medical-alt ml-1 mr-1"></i>
                                <b>Buat Dokumen DAR</b>
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-primary btn-sm"
                                @click="openModalViewDar()"
                                v-else-if="hasFinalDarDocument && allowViewDarDoc"
                              >
                                <i class="fas fa-search ml-1 mr-1"></i>
                                <b>Lihat Dokumen DAR</b>
                              </button>
                            </template>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                    <div class="col-lg-7 col-md-12 col-sm-12">
                      <div class="row">
                        <div class="col-12 border shadow-sm rounded ml-2">
                          <div class="row border-bottom title-square-background rounded-top">
                            <div class="col-12 d-flex justify-content-between mb-1 mt-1">
                              <div class="title-square">
                                <img src="~@/assets/icon/clipboard.png" alt='Informasi Tiket' width='15px' height='15px' style='margin-bottom : 4px'/>
                                 Informasi Perusahaan 
                                 </div>
                              <div v-if="ticketStatus < 3">
                                <button class="btn btn-light btn-sm" style="color: #409cff" @click="openModal('TicketInfo')" v-if="ticketStatus != 4 && ticketStatus != 3 && ticketStatus != null" ><i style='font-size:18px' class='fas'>&#xf044;</i> Edit</button>
                                <!-- <button class="btn btn-light btn-sm" @click="openModal('ChangeUnit')"><i style='font-size:18px' class='fas'>&#xf044;</i> Edit</button> -->
                              </div>
                            </div>
                          </div>
                          <table class="mb-2 mt-2">
                            <tr style="height:30px">
                              <td width='25%' style="vertical-align:top">Company Name</td>
                              <td style="vertical-align:top">&emsp;:&emsp;</td>
                              <td style="vertical-align:top">{{companyName}}</td>
                            </tr>
                            <tr style="height:30px">
                              <td style="vertical-align:top;">Company Address</td>
                              <td style="vertical-align:top">&emsp;:&emsp;</td>
                              <td style="vertical-align:top; word-wrap: break-word; max-width: 200px">{{`${companyAddress ? companyAddress : '-'}`}}</td>
                            </tr>
                            <tr style="height:30px">
                              <td width='25%' style="vertical-align:top">Asani PIC</td>
                              <td style="vertical-align:top">&emsp;:&emsp;</td>
                              <td style="vertical-align:top">{{asaniPic}}</td>
                            </tr>
                            <tr style="height:30px">
                              <td width='25%' style="vertical-align:top">Client PIC</td>
                              <td style="vertical-align:top">&emsp;:&emsp;</td>
                              <td style="vertical-align:top">{{clientPic}}</td>
                            </tr>
                            <tr style="height:30px">
                              <td width='25%' style="vertical-align:top;">Client Address</td>
                              <td style="vertical-align:top">&emsp;:&emsp;</td>
                              <td style="vertical-align:top; word-wrap: break-word; max-width: 200px">{{clientAddress ? clientAddress : '-'}}</td>
                            </tr>
                            <tr style="height:30px">
                              <td width='25%' style="vertical-align:top">Client PIC Phone</td>
                              <td style="vertical-align:top">&emsp;:&emsp;</td>
                              <td style="vertical-align:top">{{clientPicPhone}}</td>
                            </tr>
                             <tr style="height:30px">
                              <td width='25%' style="vertical-align:top">Client Email</td>
                              <td style="vertical-align:top">&emsp;:&emsp;</td>
                              <td style="vertical-align:top">{{clientPicEmail}}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row mt-3 d-flex justify-content-between">
                <h5 class="card-title">History Log</h5>
                <div class="btn-group btn-group-toggle">
                  <label :class="activeLog == 'Aktivitas' ? 'btn btn-light border active' : 'btn btn-light border'">
                    <input type="radio" name="activeLog" id="activityToggle" autocomplete="off" v-model="activeLog" :value="'Aktivitas'"> 
                    Aktivitas
                  </label>
                  <label :class="activeLog == 'Detail Produk' ? 'btn btn-light border active' : 'btn btn-light border'">
                    <input type="radio" name="activeLog" id="productDetailToggle" autocomplete="off" checked v-model="activeLog" :value="'Detail Produk'"> Detail Produk
                  </label>
                  <label :class="activeLog == 'AI Asani' ? 'btn btn-light border active' : 'btn btn-light border'">
                    <input type="radio" name="activeLog" id="productDetailToggle" autocomplete="off" checked v-model="activeLog" :value="'AI Asani'"> AI Asani
                  </label>
                </div>
              </div>
               <div class="row mt-3 d-flex" v-if="activeLog == 'AI Asani'">
                <div class="row " style="width : 100%; ">
                  <div class="col-md-12 grid-margin stretch-card card-div">
                    <div class="card border shadow-sm rounded ml-2" >
                      <div class="border-bottom title-square-background rounded-top">
                        <div class="card-title col-12 d-flex justify-content-between mb-1 mt-1">
                          <div class="title-square"> AI Asani </div>
                        </div>
                        <div class="card-title col-12 d-flex justify-content-start mb-1 mt-1">
                          <div class="mr-2">{{chatHistData ? chatHistData[0].createdAt : 'No Data'}}</div>  
                        </div>
                      </div>
                      <div v-if="chatHistData">
                        <div v-for="(data, index) in chatHistData" :key="`chatHist-${index}`">
                          <div class="card-body" style="padding: 2rem 4rem 2rem 4rem;">
                            <div v-if="data.layerDesc" style="display:flex;justify-content : flex-start">
                              <div class="chat-box-ai" style="margin-bottom :2rem;">
                                {{data.layerDesc}}
                              </div>
                            </div>
                            <div v-if="data.promptAssistent && index > 2" style="display:flex;justify-content : flex-start">
                              <div class="chat-box-ai" style="margin-bottom :2rem;white-space: pre-line">
                                <div v-html="data.promptAssistent"></div>
                              </div>
                            </div>
                            <!-- <div v-if="data.layerCode == 'AdditionalLayer' && data.promptAssistentOption" style="display:flex;justify-content : flex-start">
                              <div class="chat-box-ai" style="margin-bottom :2rem;">
                                {{data.promptAssistentOption}}
                              </div>
                            </div> -->
                            <div v-if="data.promptUserChose" style="display:flex;justify-content : flex-end">
                              <div class="chat-box-user" style="margin-bottom : 2rem;">
                                {{data.promptUserChose}}
                              </div>
                            </div>
                            <!-- <div style="display:flex;justify-content : flex-end">
                              <div class="chat-box-user" style="margin-bottom : 2rem;">
                                {{`Masih bermasalah`}}
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               </div>
              <div class="row mt-3 d-flex" v-else-if="activeLog == 'Detail Produk'">
                <div class="row ">
                  <div class="col-md-12 grid-margin stretch-card card-div">
                    <div class="card border shadow-sm rounded ml-2">
                      <div class="border-bottom title-square-background rounded-top">
                        <div class="card-title col-12 d-flex justify-content-between mb-1 mt-1">
                          <div class="title-square"> {{productCode}} </div>
                        </div>
                        <div class="card-title col-12 d-flex justify-content-start mb-1 mt-1">
                          <div class="mr-2">{{companyName}}</div>  
                          <div>
                            <i class="fas fa-info-circle mt-1" data-toggle="tooltip" title="Histori produk selama dalam masa persewaan di perusahaan tersebut"></i>
                          </div>
                        </div>
                      </div>
                      <div class="card-body" style="padding: 0px;">
                        <table class="fixed_header table-responsive rounded shadow-sm">
                          <tbody class="full-width">
                            <tr class="border">
                              <th>Ticket Number</th>
                              <th>Problem</th>
                              <th>Date</th>
                              <th>Order ID</th>
                              <th>Product Code</th>
                            </tr>
                            <tr v-if="historyDevices && historyDevices.length == 0 || !historyDevices" class="border">
                              <td colspan="5" class="text-center">Data not available</td>
                            </tr>
                            <tr v-else v-for="(data, index) in historyDevices" :key="`deviceHist-${index}`" class="border">
                              <td ><button class="btn btn-link"  @click="toDetail(data.ticketId)">{{ data.ticket_no }}</button></td>
                              <td > {{ data.problem }}</td>
                              <td > {{ data.createTime }}</td>
                              <td > {{data.orderId ? data.orderId : '-'}}</td>
                              <td > {{data.productCode ? data.productCode : productCode}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
              <div class="row mt-3 d-flex" v-else>
                <!-- <div class="row mt-3 mb-1 d-flex justify-content-end">
                  <button class="btn btn-outline-dark btn-sm float-right shadow-sm " @click="openModal('AllLog')"> View all logs </button>
                </div> -->
                 <div class="row ">
                  <div class="col-md-12 grid-margin stretch-card card-div">
                    <div class="card border shadow-sm rounded ml-2">
                      <div class="card-body" style="padding: 0px;">
                        <table class="fixed_header rounded shadow-sm">
                          <tbody class="full-width">
                            <tr v-for="(item, index) in sortedActivityLog" :key="`activityLog-${index}`">
                              <td style="border-bottom: solid 1px #dee2e6;">
                                <div class="row mt-3 mb-4" style="margin: auto;">
                                  <div class="col-9 mb-2 d-flex justify-content-start">
                                    <div>
                                      <span class="dot mr-2 mt-1" :style="'background-color:' + (index === 0 ? '#5A9AE8' : '#D9D9D9') + ';'"></span>
                                    </div>
                                    <div>
                                      <!-- created -->
                                      <template v-if="item.type === 'created'">
                                        <div class="history-title pb-2">Ticket created by {{item.by}}</div>
                                        <div class="pb-2">{{item.text}}</div>
                                        <div class="ticket-note">Notes : {{item.note}}</div>
                                      </template>
                                      <!-- internal_note -->
                                      <template v-else-if="item.type === 'internal_note'">
                                        <div class="history-title">Internal Note by {{item.by}}</div>
                                        <div>{{item.text}}</div>
                                      </template>
                                      <!-- confirmed -->
                                      <template v-else-if="item.type === 'confirmed'">
                                        <div class="history-title pb-2">Confirmed by {{item.by}} at {{item.time.split(' ')[0]}}</div>
                                        <div class="pb-2">{{item.text}}</div>
                                      </template>
                                      <!-- scheduled -->
                                      <template v-else-if="item.type === 'scheduled'">
                                        <div class="history-title pb-2">Scheduled by {{item.by}}</div>
                                        <div class="pb-2">Perbaikan akan dilakukan oleh {{asaniTechnicianName}} pada tanggal {{repairSchedule}} - {{getRepairName(repairType)}}</div>
                                      </template>
                                      <!-- rescheduled -->
                                      <template v-else-if="item.type === 'rescheduled'">
                                        <div class="history-title pb-2">Rescheduled by {{item.by}}</div>
                                        <div class="pb-2">{{item.text}}</div>
                                      </template>
                                      <!-- canceled -->
                                      <template v-else-if="item.type === 'canceled'">
                                        <div class="history-title pb-2">Canceled by {{item.by}}</div>
                                        <div class="pb-2">{{item.text}}</div>
                                      </template>
                                      <!-- repaired -->
                                      <template v-else-if="item.type === 'repaired'">
                                        <div class="history-title pb-2">Repaired by {{item.by}} ({{item.time.split(' ')[0]}})</div>
                                        <div class="pb-2">{{item.text}}</div>
                                      </template>
                                      <!-- solved -->
                                      <template v-else-if="item.type === 'solved'">
                                        <div class="history-title pb-2">Solved by {{item.by}}</div>
                                        <div class="pb-2">{{item.text}}</div>
                                      </template>
                                    </div>
                                  </div>
                                  <div class="col-3">
                                    <div class="history-title pb-2">{{item.displayTime}}</div>
                                    <button class="btn btn-link" @click="openModal('ViewAttachment')" v-if="item.type === 'created' && attachment.length != 0">Lihat Foto</button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END OF ELSE -->

              <div class="row mt-3 mb-3 d-flex" style="margin-right: -3em">
                <div class="row w-100">
                  <div class="col-md-12 grid-margin stretch-card card-div">
                    <div class="card border shadow-sm rounded ml-2">
                        <table
                          class="
                            fixed-header
                            border
                            table
                            table-responsive
                            w-100 d-block d-md-table
                          "
                        >
                          <tbody class="full-width" v-if="ticketStatus > 3 && oldProductName && (detailItem.replacementId || detailItem.upgradeFrom)">
                            <tr style="background-color:#F8F9FB;">
                              <td><div style="font-size:14pt; color:#5F6D7E;">Informasi Produk</div></td>
                              <td>
                                <div class="title-product-info">{{`${productName} ${productSpecView}`}}</div>
                                <div class="d-flex align-items-center product-label-row">
                                  <span>(Produk saat ini)</span>
                                
                                  <span class="badge-warning ml-2" v-if="detailItem.newProduct.temporary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#B45309" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                                      <line x1="12" y1="9" x2="12" y2="13"/>
                                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                                    </svg>
                                    Unit Pengganti Sementara
                                  </span>
                                  <span class="badge-success ml-2" v-else>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#15803D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                      <circle cx="12" cy="12" r="10"/>
                                      <polyline points="9 12 11 14 15 10"/>
                                    </svg>
                                    Unit Pengganti Tetap
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div class="title-product-info">{{`${oldProductName} ${oldProductSpecView}`}}</div>
                                <div class="product-label-row">
                                  <span>(Produk Sebelumnya)</span>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Order ID</td>
                              <td>{{orderId ? orderId : '-'}}</td>
                              <td>{{oldOrderId ? oldOrderId : '-'}}</td>
                            </tr>
                            <tr>
                              <td>Special Request</td>
                              <td colspan="2" class="ticket-note">{{specialRequest ? specialRequest : '-'}}</td>
                            </tr>
                            <tr>
                              <td>Product Code</td>
                              <td>{{productCode ? productCode : '-'}}</td>
                              <td>{{oldProductCode ? oldProductCode : '-'}}</td>
                            </tr>
                            <tr>
                              <td>Product Type</td>
                              <td>{{productTypeName ? productTypeName : '-'}}</td>
                              <td>{{oldProductTypeName ? oldProductTypeName : '-'}}</td>
                            </tr>
                            <tr>
                              <td>Model</td>
                              <td>{{productModel ? productModel : '-'}}</td>
                              <td>{{oldProductModel ? oldProductModel : '-'}}</td>
                            </tr>
                            <tr v-if="detailItem.productType < 3">
                              <td>Bom Items</td>
                              <td>
                                <div v-if="bomItems && bomItems.length">
                                  <div v-for="(item, index) in bomItems" :key="`bomItem-${index}`">
                                    {{item.itemGroup}} : {{ item.itemName }} (Qty : {{item.itemQty}})
                                  </div>
                                </div>
                                <div v-else-if="actualSpec">
                                  <div v-for="(value, name) in JSON.parse(detailItem.newProduct.actual)" :key="value +'x'">
                                    {{name}} : {{ value }}
                                  </div>
                                </div>
                                <div v-else>
                                  -
                                </div>
                              </td>
                              <td>
                                <div v-if="oldBomItems && oldBomItems.length">
                                  <div v-for="(item, index) in oldBomItems" :key="`oldBomItem-${index}`">
                                    <div>{{item.itemGroup}} : {{ item.itemName }} (Qty : {{item.itemQty}})</div>
                                  </div>
                                </div>
                                <div v-else-if="oldActualSpec">
                                  <div v-for="(value, name) in JSON.parse(oldActualSpec)" :key="value +'x'">
                                    {{name}} : {{ value }}
                                  </div>
                                </div>
                                <div v-else>
                                  -
                                </div>
                              </td>
                              <!-- </div> -->
                            </tr>
                            <tr v-else-if="detailItem.productType > 2">
                              <td>Specifications</td>
                              <td>
                                <div v-if="actualSpec">
                                  <div v-for="(value, name) in JSON.parse(actualSpec)" :key="value +'k'">
                                    {{name}} : {{ value }}
                                  </div>
                                </div>
                                <div v-else>
                                  -
                                </div>
                              </td>
                              <td>
                                <div v-if="oldActualSpec">
                                  <div v-for="(value, name) in JSON.parse(oldActualSpec)" :key="value +'k'">
                                    {{name}} : {{ value }}
                                  </div>
                                </div>
                                <div v-else>
                                  -
                                </div>
                              </td>
                            </tr>
                            
                            <tr>
                              <td>SN</td>
                              <td>{{productSN ? productSN : '-'}}</td>
                              <td>{{oldProductSN ? oldProductSN : '-'}}</td>
                            </tr>
                            <tr>
                              <td>Windows License </td>
                              <td>{{windowsLicense ? windowsLicense : '-'}}</td>
                              <td>{{oldWindowsLicense ? oldWindowsLicense : '-'}}</td>
                            </tr>
                            <tr>
                              <td>Office License</td>
                              <td>{{officeLicense ? officeLicense : '-'}}</td>
                              <td>{{oldOfficeLicense ? oldOfficeLicense : '-'}}</td>
                            </tr>
                            <tr>
                              <td>Condition</td>
                              <td>{{productCondition ? productCondition : '-'}}</td>
                              <td>{{oldProductCondition ? oldProductCondition : '-'}}</td>
                            </tr>
                            <tr>
                              <td>End Rent</td>
                              <td>{{endRent ? endRent : '-'}}</td>
                              <td>{{oldEndRent ? oldEndRent : '-'}}</td>
                            </tr>
                          </tbody>
                          <tbody class="full-width" v-else>
                            <tr style="background-color:#F8F9FB;">
                              <td><div style="font-size:14pt; color:#5F6D7E;">Informasi Produk</div></td>
                              <td>
                                <div class="title-product-info" style="font-size: 10pt">{{`${productName} ${productSpecView}`}}</div>
                                (Produk saat ini)
                              </td>
                              <td v-if="ticketStatus < 3">
                                <button class="btn btn-outline-primary btn-sm float-right" @click="openModal('ChangeUnit')">
                                    <i style='font-size:18px' class='fas'>&#xf044;</i>
                                    Ganti Unit
                                </button>
                              </td>
                            </tr>
                            <tr class="border">
                              <td>Order ID</td>
                              <td colspan="2">{{orderId ? orderId : '-'}}</td>
                            </tr>
                            <tr class="border">
                              <td>Special Request</td>
                              <td colspan="2" class="ticket-note">{{specialRequest ? specialRequest : '-'}}</td>
                            </tr>
                            <tr class="border">
                              <td>Product Code</td>
                              <td colspan="2">{{productCode ? productCode : '-'}}</td>
                            </tr>
                            <tr class="border">
                              <td>Product Type</td>
                              <td colspan="2">{{productTypeName ? productTypeName : '-'}}</td>
                            </tr>
                            <tr class="border">
                              <td>Model</td>
                              <td colspan="2">{{productModel ? productModel : '-'}}</td>
                            </tr>
                            <tr v-if="detailItem.productType < 3">
                              <td>Bom Items</td>
                              <!-- <div v-if="detailItem.productType < 3 && detailItem.oldProduct.bomItem.length && detailItem.newProduct.bomItem.length"> -->
                              <td>
                                <div v-if="bomItems && bomItems.length">
                                  <div v-for="(item, index) in bomItems" :key="`bomItem-${index}`">
                                    {{item.itemGroup}} : {{ item.itemName }} (Qty : {{item.itemQty}})
                                  </div>
                                </div>
                                <div v-else-if="actualSpec">
                                  <div v-for="(value, name) in JSON.parse(actualSpec)" :key="value +'x'">
                                    {{name}} : {{ value }}
                                  </div>
                                </div>
                                <div v-else>
                                  -
                                </div>
                              </td>
                            </tr>
                            <tr v-else-if="detailItem.productType > 2">
                              <td>Specifications</td>
                              <td>
                                <div v-if="actualSpec">
                                  <div v-for="(value, name) in JSON.parse(actualSpec)" :key="value +'k'">
                                    {{name}} : {{ value }}
                                  </div>
                                </div>
                                <div v-else>
                                  -
                                </div>
                              </td>
                            </tr>
                            <tr class="border">
                              <td>SN</td>
                              <td colspan="2">{{productSN ? productSN : '-'}}</td>
                            </tr>
                            <tr class="border">
                              <td>Windows License </td>
                              <td colspan="2">{{windowsLicense ? windowsLicense : '-'}}</td>
                            </tr>
                            <tr class="border">
                              <td>Office License</td>
                              <td colspan="2">{{officeLicense ? officeLicense : '-'}}</td>
                            </tr>
                            <tr class="border">
                              <td>Condition</td>
                              <td colspan="2">{{productCondition ? productCondition : '-'}}</td>
                            </tr>
                            <tr class="border">
                              <td>End Rent</td>
                              <td colspan="2">{{endRent ? endRent : '-'}}</td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row mt-3 mb-3">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <h5 class="card-title" style="margin-top: .75rem">Case History</h5>
                  <button class="btn btn-outline-dark btn-sm float-right shadow-sm" @click="openModal('AllLog')"> View all logs </button>
                </div>
                <div class="card w-100">
                  <div class="card-body rounded shadow-sm p-10">
                    <div class="history-title pb-2">Ticket created by {{createBy}} at {{createTime}}</div>
                    <div class="pb-2">{{problem}}</div>
                    <div class="d-flex flex-row" v-if="attachment.length != 0">
                      <div class="images" v-viewer>
                        <img v-for="src in attachment" :src="src" :key="src" class="img-responsive img-thumbnail">
                      </div>
                    </div>
                    <div class="ticket-note">Notes : {{ticketNote}}</div>
                  </div>
                </div>
              </div>

              <div v-for="data in internalNoteCreated">
                <div class="row mt-3 mb-3">
                  <div class="card w-100">
                    <div class="card-body rounded shadow-sm p-10">
                      <div class="history-title">Internal Note by {{data.by}} at {{data.time}}</div>
                      <div>{{data.text}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3 mb-3" v-if="ticketStatus > 0 && confirmedTime != null">
                <div class="card w-100">
                  <div class="card-body rounded shadow-sm p-10">
                    <div class="history-title pb-2">Confirmed by {{confirmedBy}} at {{confirmedTime}}</div>
                    <div class="pb-2">{{confirmedNote}}</div>
                  </div>
                </div>
              </div>

              <div v-for="data in internalNoteConfirmed">
                <div class="row mt-3 mb-3">
                  <div class="card w-100">
                    <div class="card-body rounded shadow-sm p-10">
                      <div class="history-title">Internal Note by {{data.by}} at {{data.time}}</div>
                      <div>{{data.text}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3 mb-3" v-if="ticketStatus > 1 && repairScheduleTime != null">
                <div class="card w-100">
                  <div class="card-body rounded shadow-sm p-10">
                    <div class="history-title pb-2">Scheduled by {{repairScheduleBy}} at {{repairScheduleTime}}</div>
                    <div class="pb-2">Perbaikan akan dilakukan oleh {{asaniTechnicianName}} pada tanggal {{repairSchedule}} - {{getRepairName(repairType)}}</div>
                  </div>
                </div>
              </div>

              <div v-for="data in internalNoteScheduled">
                <div class="row mt-3 mb-3">
                  <div class="card w-100">
                    <div class="card-body rounded shadow-sm p-10">
                      <div class="history-title">Internal Note by {{data.by}} at {{data.time}}</div>
                      <div>{{data.text}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3 mb-3" v-if="ticketStatus == 99">
                <div class="card w-100">
                  <div class="card-body rounded shadow-sm p-10">
                    <div class="history-title pb-2">Canceled by {{canceledBy}} at {{canceledTime}}</div>
                    <div class="pb-2">{{canceledNote}}</div>
                  </div>
                </div>
              </div>

              <div class="row mt-3 mb-3" v-if="ticketStatus > 2 && repairedTime != null && ticketStatus !== 99">
                <div class="card w-100">
                  <div class="card-body rounded shadow-sm p-10">
                    <div class="history-title pb-2">Repaired by {{asaniTechnicianName}} at {{repairedTime}}</div>
                    <div class="pb-2">{{repairedNote}}</div>
                  </div>
                </div>
              </div>

              <div class="row mt-3 mb-3" v-if="ticketStatus > 3 && ticketStatus !== 99">
                <div class="card w-100">
                  <div class="card-body rounded shadow-sm p-10">
                    <div class="history-title pb-2">Solved by {{solvedBy}} at {{solvedTime}}</div>
                    <div class="pb-2">{{solvedNote}}</div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="row d-flex flex-row-reverse">
                <button class="btn btn-primary float-right shadow-sm btn-sm" @click="openModal('Confirm')" v-if="ticketStatus == 0"> Confirm Ticket </button>

                <button class="btn btn-primary float-right shadow-sm btn-sm" @click="openModal('ReopenCase')" v-if="ticketStatus == 3"> Reopen Case </button>
                <button class="btn btn-danger float-right shadow-sm btn-sm" :style="{'margin-right' : 10 +'px'}" @click="openModal('Cancel')" v-if="ticketStatus < 3 && ticketPurpose == 'Kendala' && cancelResolution"> Cancel Ticket </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalChangeUnit" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Ganti Unit</h4>
            Ubah unit yang mengalami gangguan
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row mb-1">
              <strong>Product Code </strong>
            </div>
            <div class="row align-items-center justify-content-between">
              <div class="col-lg-2 px-0">
                <h6 class="mr-2 mb-0">{{productCode}}</h6>
              </div>
              <i class='fas'>&#xf061;</i>
              <div class="col-lg-9 px-0">
                <multiselect v-model="selectSwitchUnit" :options="switchUnitList" label="uniqueId" :allow-empty="false" deselect-label="" select-label="" class="mr-1" track-by="uniqueId" placeholder="None">
                  <template slot="noResult">Unit tidak ditemukan.</template>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" :disabled="selectSwitchUnit.orderDetailsId == ''" @click="submitSwitchUnit">Save</button>
          <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalAllLog" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Log {{ticketNumber}}</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="fixed_header table-bordered table-striped">
            <tbody class="full-width">
              <tr>
                <th style="min-width: 150px;">When</th>
                <th style="min-width: 400px;">What</th>
                <th style="min-width: 200px;">Who</th>
              </tr>
              <tr v-if="logResolution.length == 0">
                <td colspan="3">Tidak ada Log</td>
              </tr>
              <tr v-else v-for="(data, index) in logResolution" :key="`logRes-${index}`">
                <td> {{ data.time }}</td>
                <td> {{ data.text }}</td>
                <td> {{ data.ids }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalConfirm" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Confirm Ticket</h4>
            Konfirmasi tiket agar bisa dilanjutkan ke tim IT Suppport.
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="mt-2 mb-3">
            Nomor Tiket  : {{ticketNumber}}
          </div>
          <div class="mb-1">
            <strong>Konfirmasi Pelapor </strong>
          </div>
          <div class="mb-2">
            <multiselect v-model="selectedClientConfirmationNote" :options="clientConfirmationNoteOptions" label="confirmationNote" track-by="confirmationNote" :allow-empty="false" deselect-label="" placeholder="Pilih status konfirmasi" :class="{ 'error-field-text': fieldClientConfirmError }"></multiselect>
            <div class="error-text-message" v-if="fieldClientConfirmError && !selectedClientConfirmationNote.confirmationNote">*Required fields</div>
          </div>
          
          <div class="mb-1">
            <div><textarea placeholder="Note, Example : Klien berhasil dihubungi dan permasalahan pada layar, teknisi akan menjadwalkan perbaikan langsung" rows="5" style="resize: none;" v-model="confirmedNoteSubmit" class="w-100 rounded confirm" :class="{ 'error-field-text': fieldConfirmError }" @input="validateSelf('confirm')"></textarea></div>
            <div class="error-text-message" v-if="fieldConfirmError">*Required fields</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-primary btn-sm" data-dismiss="modal">Kembali</button>
          <button type="button" class="btn btn-primary btn-sm" @click="submitConfirm" v-if="loadingButtonProcess == false">Konfirmasi</button>
          <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Konfirmasi</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalTicketInfo" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Ticket Info</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div class="text-title-field" :class="{ 'error-text': fieldAsaniPICError}">Asani PIC</div>
            <multiselect v-model="asaniPicChoose" :options="asaniPicSelect" label="employeeName" track-by="employeeName" :allow-empty="false" deselect-label="" placeholder="Select Asani PIC" :class="{'error-field' : fieldAsaniPICError}" @click="validateSelf('asaniPicChoose')"></multiselect>
            <div class="error-text-message" v-if="fieldAsaniPICError">Asani PIC required fields</div>
          </div>

          <div class="form-group" :class="{ 'form-group--error': $v.clientPicSubmit.$error }">
            <label class="form__label">Client PIC Name</label>
            <input class="form__input" v-model.trim="$v.clientPicSubmit.$model" placeholder="Client PIC Name" />
          </div>
          <div class="error" v-if="!$v.clientPicSubmit.required">Client PIC name required fields</div>

          <div class="form-group" :class="{ 'form-group--error': $v.clientPicPhoneSubmit.$error }">
            <label class="form__label">Client PIC Phone</label>
            <div class="d-flex">
              <input class="form__input" v-model.trim="$v.clientPicPhoneSubmit.$model" @keypress="isNumber($event)" placeholder="Client PIC Phone" @input="toPhoneFormat(clientPicPhoneSubmit)" />
            </div>
          </div>
          <div class="error" v-if="!$v.clientPicPhoneSubmit.required">Client PIC phone required fields</div>
          <div class="error" v-if="!$v.clientPicPhoneSubmit.phoneFormat">Wrong format, please use 628 or 08 or 02</div>

          <div class="form-group" :class="{ 'form-group--error': $v.clientPicAddressSubmit.$error }">
            <label class="form__label">Client Address</label>
            <textarea class="form__input" rows='3'  v-model.trim="$v.clientPicAddressSubmit.$model" placeholder="Client Address" ></textarea>
          </div>
          <div class="error" v-if="!$v.clientPicAddressSubmit.required">Client Address required fields</div>
          <!-- <div><textarea rows="5" style="resize: none;" v-model="clientAddress" class="w-100 rounded problem" :class="{ 'error-field-text': fieldClientAddressError }" @input="validateSelf('clientAddress')"></textarea></div> -->
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" @click="submitEditTicketInfo" :disabled="loadingButtonProcess">
            <img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingButtonProcess">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalRepairInfo" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Repair Info</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div class="text-title-field" :class="{ 'error-text': fieldAsaniTechnicianError}">Technician</div>
            <multiselect v-model="asaniTechnician" :options="asaniPicSelect" label="employeeName" track-by="employeeName" :allow-empty="false" deselect-label="" placeholder="Select Asani Technician" :class="{'error-field' : fieldAsaniTechnicianError}" @click="validateSelf('asaniPicTechnician')"></multiselect>
            <div class="error-text-message" v-if="fieldAsaniTechnicianError">Technician required fields</div>
          </div>

          <div class="mb-3">
            <div class="text-title-field" :class="{ 'error-text': fieldRepairScheduleError}">Repair Schedule</div>
            <input type="date" v-model="repairScheduleSubmit" class="form-control repair-schedule" :class="{ 'error-field-text': fieldRepairScheduleError }" @input="validateSelf('repairSchedule')">
            <div class="error-text-message" v-if="fieldRepairScheduleError">Repair schedule required fields</div>
          </div>

          <div class="mb-3">
            <div class="text-title-field" :class="{ 'error-text': fieldAsaniTechnicianError}">Repair Type</div>
            <multiselect v-model="repairTypeSubmit" :options="repairTypeSelect" label="repairName" track-by="repairName" :allow-empty="false" deselect-label="" placeholder="Repair Type" :class="{'error-field' : fieldRepairTypeError}" @click="validateSelf('repairTypeSubmit')"></multiselect>
            <div class="error-text-message" v-if="fieldRepairTypeError">Repair type required fields</div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" @click="submitEditRepairInfo" :disabled="loadingButtonProcess">
            <img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingButtonProcess">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalReopenCase" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <!-- <h4 class="modal-title" v-if="reopenChoose.case == 1 && caseKnowledgeShow">New Case/Problem </h4> -->
            <h4 class="modal-title">{{!endOfCase ? 'Reopen Tiket' : 'Buat Tiket'}}</h4>
            <div v-if="caseKnowledgeShow && !isSolution && !endOfCase">
              Pilih bagian produk yang bermasalah
            </div>
            <div v-else-if="caseKnowledgeShow && isSolution && !endOfCase">
              Silakan coba solusi ini
            </div>
            <div v-else-if="!caseKnowledgeShow && !loadingCase && !endOfCase">
              Bagaimana Kondisinya saat ini?
            </div>
            <div v-else-if="!caseKnowledgeShow && !loadingCase">
              Masukkan detail permasalah lebih lanjut
            </div>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body" v-if="!caseKnowledgeShow && !loadingCase">
          <div v-for="data in reopenSelect" :key="data.case">
            <div v-if="reopenChoose.reopenText == data.reopenText">
              <div class="case-knowledge border border-primary rounded w-100 mb-3 p-2" style="background-color : #F1F7FE; color :#2797FB; " @click="setReopenChoose(data)">
                <div class="mt-2 mb-2 ml-2">{{ data.reopenText }}</div>
              </div>
            </div>
            <div v-else>
              <div class="case-knowledge border border-secondary rounded w-100 mb-3 p-2" @click="setReopenChoose(data)">
                <div class="mt-2 mb-2 ml-2">{{ data.reopenText }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body" v-else-if="caseKnowledgeShow && !isSolution && !endOfCase">
          <div v-if="!loadingCase">
            <div v-for="(data, index) in caseKnowledge" :key="data.text">
              <div v-if="caseKnowledge.length >= 10">
                <div class="row justify-content-md-center" v-if="index +1  <= caseKnowledge.length/2">
                  <div class="col-5 mr-2 case-knowledge border border-secondary rounded w-100 mb-2 p-2" @click="getCaseKnowledge(data.id,data.solution,data.deviceStatus,data.idBefore,'next')"> 
                    <i class="fas fa-power-off" v-if="data.text == 'Power & Charger'"></i>
                    <i class="fas fa-desktop" v-if="data.text == 'Layar'"></i>
                    <i class="fas fa-globe" v-if="data.text == 'Internet'"></i>
                    <i class="fas fa-keyboard" v-if="data.text == 'Keyboard'"></i>
                    <i class="fas fa-tablet" v-if="data.text == 'Trackpad'"></i>
                    {{ data.text }}
                  </div>
                   
                  <div class="col-5 case-knowledge border border-secondary rounded w-100 mb-2 p-2" @click="getCaseKnowledge(caseKnowledge[index + (caseKnowledge.length/2)].id,caseKnowledge[index + (caseKnowledge.length/2)].solution,caseKnowledge[index + (caseKnowledge.length/2)].deviceStatus,caseKnowledge[index + (caseKnowledge.length/2)].idBefore,'next')"> 
                    <i class="fab fa-usb" v-if="caseKnowledge[index + (caseKnowledge.length/2)].text == 'USB Port'"></i>
                    <i class="fa fa-microphone " v-if="caseKnowledge[index + ((caseKnowledge.length/2))].text == 'Speaker & Microphone'"></i>
                    <i class="fas fa-camera" v-if="caseKnowledge[index + (caseKnowledge.length/2)].text == 'Kamera'"></i>
                    <i class="fa fa-tachometer-alt" v-if="caseKnowledge[index + (caseKnowledge.length/2)].text == 'Performance'"></i>
                    <i class="fas fa-microchip" v-if="caseKnowledge[index + (caseKnowledge.length/2)].text == 'Software'"></i>
                    {{ caseKnowledge[index + ((caseKnowledge.length/2))].text }}
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="case-knowledge border border-secondary rounded w-100 mb-2 text-center p-2" @click="getCaseKnowledge(data.id,data.solution,data.deviceStatus,data.idBefore,'next')">
                  {{ data.text }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="loadingCase">
            <div class="border border-secondary rounded w-100 mb-2 text-center p-2">
              <img src="~@/assets/images/load-button.gif">
            </div>
          </div>
        </div>
        <div class="modal-body" v-else-if="caseKnowledgeShow && isSolution && !endOfCase">
          <div v-if="!loadingCase">
            <div v-for="(data, index) in caseKnowledge" :key="`knowledge-${index}`" >
              <div class="border border-secondary rounded w-100 mb-2 text-center p-2">
                {{ data.text }}</div>
            </div>
          </div>
          <div v-if="loadingCase">
            <div class="border border-secondary rounded w-100 mb-2 text-center p-2">
              <img src="~@/assets/images/load-button.gif">
            </div>
          </div>
        </div>
        <div class="modal-body" v-else-if="endOfCase">
          <div class="mb-3" v-if="caseInfo != '' || caseInfo != null"> {{ caseInfo }} </div>
          <div class="mb-3">
            <div class="text-title-field w-100" :class="{ 'error-text': fieldProblemError }">Info detail mengenai permasalahan device</div>
            <div><textarea rows="5" style="resize: none;" v-model="problemSubmit" class="w-100 rounded problem" :class="{ 'error-field-text': fieldProblemError }" @input="validateSelf('problem')"></textarea></div>
            <div class="error-text-message" v-if="fieldProblemError">*Required fields</div>
          </div>
          <div class="mb-3">
            <div class="text-title-field">Catatan</div>
            <div><textarea rows="3" style="resize: none;" v-model="reopenNote" class="w-100 rounded"></textarea></div>
          </div>
          <div class="mb-3">
            <div class="text-title-field w-100" :class="{ 'error-text': fieldReopenClientAddressError }">Alamat Client</div>
            <div><textarea rows="5" style="resize: none;" v-model="reopenClientAddress" class="w-100 rounded problem" :class="{ 'error-field-text': fieldReopenClientAddressError }" @input="validateSelf('clientAddress')"></textarea></div>
            <div class="error-text-message" v-if="fieldReopenClientAddressError">Field wajib diisi !</div>
          </div>
          <div class="mb-3">
            <div class="text-title-field">Attachment 1</div>
            <div class="d-flex">
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="attachment_1" @change="onFilePicked($event,0)">
                <label class="custom-file-label" for="customFile">{{reopenAttachment[0].fileName}}</label>
              </div>
              <button class="btn btn-danger ml-2" v-if="reopenAttachment[0].fileBase64 != ''" @click="deleteAttachment(0)">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="mb-3">
            <div class="text-title-field">Attachment 2</div>
              <div class="d-flex">
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="attachment_2" @change="onFilePicked($event,1)">
                  <label class="custom-file-label" for="customFile">{{reopenAttachment[1].fileName}}</label>
                </div>
                <button class="btn btn-danger ml-2" v-if="reopenAttachment[1].fileBase64 != ''" @click="deleteAttachment(1)">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
            </div>
          </div>
          <div class="mb-3">
            <div class="text-title-field">Attachment 3</div>
            <div class="d-flex">
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="attachment_3" @change="onFilePicked($event,2)">
                <label class="custom-file-label" for="customFile">{{reopenAttachment[2].fileName}}</label>
              </div>
              <button class="btn btn-danger ml-2" v-if="reopenAttachment[2].fileBase64 != ''" @click="deleteAttachment(2)">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-dark btn-sm" v-if="!caseKnowledgeShow || endOfCase" @click="closeModal()">Batalkan</button>
          <button type="button" style="color: #409cff" class="btn btn-light btn-sm float-left" v-else-if="caseKnowledgeShow && !loadingButtonBack && !endOfCase" @click="getCaseKnowledge(null,'',null,'','back')" :disabled="caseKnowledgeShow && loadingButtonBack"> <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="caseKnowledgeShow && loadingButtonBack">{{'< Sebelumnya'}}</button>

          <button type="button" style="color: #409cff" class="btn btn-light btn-sm" v-if="caseKnowledgeShow && isSolution" @click="getCaseKnowledge(caseKnowledge[0].id,caseKnowledge[0].solution,caseKnowledge[0].deviceStatus,caseKnowledge[0].idBefore,'still')" :disabled="loadingButtonStill && caseKnowledgeShow && isSolution"> <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingButtonStill && caseKnowledgeShow && isSolution">Masih Bermasalah</button>

          <button type="button" class="btn btn-primary btn-sm" v-if="caseKnowledgeShow && isSolution && !endOfCase" @click="submitReopenTicket('solved')" :disabled="loadingButtonSolved && caseKnowledgeShow && isSolution && !endOfCase">
            <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingButtonSolved && caseKnowledgeShow && isSolution && !endOfCase">
            Terselesaikan
          </button>

          <button type="button" class="btn btn-primary btn-sm" v-if="reopenChoose.case == 1 && !caseKnowledgeShow" @click="getCaseKnowledge(null,'',null,null,'next')" :disabled="loadingButtonNext && reopenChoose.case == 1">
            <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingButtonNext && reopenChoose.case == 1">
            Selanjutnya
          </button>

          <button type="button" class="btn btn-primary btn-sm" v-if="reopenChoose.case == 0" :disabled="loadingButtonProcess && reopenChoose.case == 0" @click="submitReopenTicket('save')">
            <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingButtonProcess && reopenChoose.case == 0">
            Buat tiket
          </button>

          <button type="button" class="btn btn-primary btn-sm" v-if="caseKnowledgeShow && !isSolution && endOfCase" @click="submitReopenTicket('new problem')" :disabled="loadingButtonProcess && caseKnowledgeShow && !isSolution && endOfCase">
            <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingButtonProcess && caseKnowledgeShow && !isSolution && endOfCase">
            Buat tiket
          </button>

        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalCancel" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Cancel Ticket</h4>
            Berikan alasan cancel tiket
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            Nomor Tiket : <b>{{ticketNumber}}</b>
          </div>
          <div class="mb-3">
            <div><textarea rows="5" style="resize: none;" placeholder="Alasan pembatalan tiket" v-model="cancelTicketReason" class="w-100 rounded confirm" :class="{ 'error-field-text': fieldCancelError }" @input="validateSelf('cancel')"></textarea></div>
            <div class="error-text-message" v-if="fieldCancelError">{{!this.cancelTicketReason ?  '*Required fields' : this.cancelTicketReason.length > 250 ? '*Maximum 250 characters' : '*Required fields'}}</div>
          </div>
          
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-dark btn-sm" data-dismiss="modal">Kembali</button>
          <button type="button" class="btn btn-danger btn-sm" @click="cancelTicket" v-if="loadingButtonProcess == false">Batalkan tiket</button>
          <button type="button" class="btn btn-danger btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Batalkan tiket</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalViewAttachment" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="d-flex justify-content-center">
          <img :src="attachment[attachmentViewedIdx]" :key="attachment[attachmentViewedIdx]" style="width:100%;">
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <div v-if="attachment.length > 0">
            <button type="button" :disabled="attachmentViewedIdx == 0" class="btn btn-link btn-sm" @click="handleChangeAttachmentView('prev')">
              <i class="fas fa-angle-left" style="font-size:16pt"></i>
            </button>
            <button type="button" :disabled="attachmentViewedIdx == attachment.length-1" class="btn btn-link btn-sm" @click="handleChangeAttachmentView('next')">
              <i class="fas fa-angle-right" style="font-size:16pt"></i>
            </button>
          </div>
          <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal">Tutup</button>
        </div>
      </div>
    </div>
  </div>
  <ModalFormDar
    :ticketId="ticketId"
    :ticketNumber="ticketNumber"
    :technicianName="asaniTechnicianName"
    :orderId="orderId"
    :productCode="productCode"
    :productTypeName="productTypeName"
    :productModel="productModel"
    :productSN="productSN"
    :bomItems="bomItems"
    :darDetail="darDetailData"
    @save-draft="handleDarSaveDraft"
    @submit="handleDarSubmit"
    @onUnauthorized="handleLogout"
  />
  <ModalViewDar
    :darDetail="darDetailData"
    :loadingDownload="loadingDownloadDar"
    :createdBy="admin"
    @edit="handleEditFromViewDar"
    @download="downloadDarDoc"
  />
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import SideBar from '../SideBar'
import 'viewerjs/dist/viewer.css'
import { required, minLength } from 'vuelidate/lib/validators'
import Swal from 'sweetalert2'
import ModalFormDar from './CustomComponent/DAR/ModalFormDar.vue'
import ModalViewDar from './CustomComponent/DAR/ModalViewDar.vue'
export default {
  name: 'ResolutionCenterDetailPage',
  components: {
    SideBar,
    Multiselect,
    ModalFormDar,
    ModalViewDar
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
      admin: "",
      handoverUrl: '',
      handoverTime: '',
      permission: [],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      cancelResolution : false,
      allowViewDarDoc: false,
      allowEditDarDoc: false,
      allowCreateDarDoc: false,
      companyId: null,
      companyName: null,
      companyAddress : null,
      ticketStatus: null,
      ticketPurpose: null,
      ticketNumber: null,
      asaniPic: null,
      asaniPicId: null,
      clientPic: null,
      clientAddress : null,
      clientPicPhone: null,
      clientPicEmail : null,
      problemCategory: null,
      asaniTechnician: {
        id: null,
        employeeName: null
      },
      fieldAsaniTechnicianError: false,
      asaniTechnicianName: null,
      asaniTechnicianId: null,
      repairSchedule: null,
      repairScheduleBy: null,
      repairScheduleTime: null,
      orderId: null,
      productCode: null,
      productName : null,
      productType: null,
      productTypeName: null,
      productModel: null,
      productVarian: null,
      productSpecView: '',
      productSN: null,
      windowsLicense: null,
      officeLicense: null,
      productCondition: null,
      endRent: null,
      bomItems : null,
      actualSpec : null,
      // product Sebelumnya
      oldOrderId: null,
      oldProductCode: null,
      oldProductName : null,
      oldProductType: null,
      oldProductTypeName: null,
      oldProductModel: null,
      oldProductVarian: null,
      oldProductSpecView: '',
      oldProductSN: null,
      oldWindowsLicense: null,
      oldOfficeLicense: null,
      oldProductCondition: null,
      oldEndRent: null,
      oldBomItems:null,
      oldActualSpec : null,
      historyDevices: [],
      createBy: null,
      createTime: null,
      problem: null,
      attachment: [],
      specialRequest: '',
      ticketNote: null,
      internalNotes: [],
      internalNoteConfirmed: [],
      internalNoteCreated: [],
      internalNoteScheduled: [],
      logResolution: [],
      loadingButtonProcess: false,
      fieldClientConfirmError: false,
      fieldConfirmError: false,
      fieldAsaniPICError: false,
      confirmedNoteSubmit: null,
      confirmedNote: null,
      confirmedBy: null,
      confirmedTime: null,
      repairType: null,
      asaniPicChoose: {
        id: null,
        employeeName: 'Asani PIC'
      },
      clientPicSubmit: null,
      clientPicPhoneSubmit: '',
      clientPicAddressSubmit: null,
      asaniPicSelect: [],
      repairedNote: null,
      repairedTime: null,
      repairedDate:null,
      reopenChoose: {
        case: null,
        reopenText: 'Select One'
      },
      reopenSelect: [{
        case: 0,
        reopenText: 'The same problem still happening'
      }, {
        case: 1,
        reopenText: 'New Problem/Case'
      }],
      fieldReopenError: false,
      caseKnowledgeShow: false,
      loadingButtonBack: false,
      idBefore: [],
      loadingButtonNext: false,
      loadingCase: false,
      loadingButtonSolved: false,
      loadingButtonStill: false,
      isSolution: false,
      caseInfo: '',
      endOfCase: false,
      problemSubmit: null,
      fieldProblemError: false,
      caseChoose: null,
      solvedNote: null,
      solvedTime: null,
      solvedBy: null,
      caseIdProblem: null,
      repairScheduleSubmit: null,
      repairTypeSubmit: null,
      orderLessorId: 0,
      orderLessorName: "",
      repairTypeSelect: [{
          type: 0,
          repairName: 'Visit'
        },
        {
          type: 1,
          repairName: 'Remote'
        }
      ],
      fieldRepairScheduleError: false,
      fieldRepairTypeError: false,
      deviceStatus: null,
      deviceStatusChoose: null,
      detailItem: [],
      selectSwitchUnit: { orderDetailsId: '', uniqueId: 'None' },
      switchUnitList: [{ orderDetailsId: '', uniqueId: 'None' }],
      cancelTicketReason: null,
      fieldCancelError: false,
      cancelededNote: null,
      cancelededBy: null,
      cancelededTime: null,
      ticketActionBoxTheme : '',
      ticketActionBoxText : {
        title : '',
        description : ''
      },
      ticketPurposeTheme : {
        bgColor : '',
        borderColor : '',
      },
      activeLog : 'Aktivitas',
      hasUpgraded : false,
      attachmentViewedIdx : 0, 
      reopenNote : null,
      reopenClientAddress : null,
      fieldReopenClientAddressError: false,
      reopenAttachment:[
        {
          fileName:'Choose file...',
          fileBase64:''
        },
        {
          fileName:'Choose file...',
          fileBase64:''
        },
        {
          fileName:'Choose file...',
          fileBase64:''
        }
      ],
      clientConfirmationNoteOptions : [],
      selectedClientConfirmationNote : {
        id : 0,
        confirmationNote : ''
      },
      ticketBastInfo : false,
      loadingDownloadTicketBast : false,
      darDetailData : null,
      loadingDownloadDar : false,
    }
  },
  validations: {
    clientPicSubmit: {
      required
    },
    clientPicPhoneSubmit: {
      required,
      phoneFormat(phoneNumber) {
        return (
          phoneNumber.toString().substring(0, 3) == '628' ||
          phoneNumber.toString().substring(0, 2) == '08' ||
          phoneNumber.toString().substring(0, 2) == '02'
        )
      },
    },
    clientPicAddressSubmit: {
      required
    },
    validationTicketInfo: ['clientPicSubmit', 'clientPicPhoneSubmit','clientPicAddressSubmit'],
    chatHistData : [],
  },
  computed: {
    hasFinalDarDocument() {
      return !!this.darDetailData && this.darDetailData.asDraft === 0 && !!this.darDetailData.createdAt
    },
    ticketStatusBadge() {
      const themes = {
        0: { text: 'Pending', bgColor: '#FEF8E8', textColor: '#8A6D1D' },
        1: { text: 'Confirmed', bgColor: '#F1F7FE', textColor: '#2C6FBB' },
        2: { text: 'Scheduled', bgColor: '#F1F7FE', textColor: '#2C6FBB' },
        3: { text: 'Repaired', bgColor: '#FEF3E8', textColor: '#B4620E' },
        4: { text: 'Solved', bgColor: '#F0FDF4', textColor: '#15803D' },
        99: { text: 'Canceled', bgColor: '#FFE9EA', textColor: '#CC444A' },
      }
      return themes[this.ticketStatus] || null
    },
    sortedActivityLog() {
      const logs = []

      if (this.createTime) {
        logs.push({
          type: 'created',
          time: new Date(this.createTime),
          displayTime: this.createTime,
          by: this.createBy,
          text: this.problem,
          note: this.ticketNote,
          isActive: this.ticketStatus == 0,
        })
      }

      this.internalNoteCreated.forEach(note => {
        logs.push({
          type: 'internal_note',
          time: new Date(note.time),
          displayTime: note.time,
          by: note.by,
          text: note.text,
          isActive: false,
        })
      })

      if (this.confirmedTime && this.ticketStatus > 0) {
        logs.push({
          type: 'confirmed',
          time: this.confirmedTime,
          displayTime: this.confirmedTime,
          by: this.confirmedBy,
          text: this.confirmedNote,
          isActive: this.ticketStatus == 1,
        })
      }

      this.internalNoteConfirmed.forEach(note => {
        logs.push({
          type: 'internal_note',
          time: new Date(note.time),
          displayTime: note.time,
          by: note.by,
          text: note.text,
          isActive: false,
        })
      })

      if (this.repairScheduleTime && this.ticketStatus > 1 && this.ticketStatus !== 99) {
        logs.push({
          type: 'scheduled',
          time: new Date(this.repairScheduleTime),
          displayTime: this.repairScheduleTime,
          by: this.repairScheduleBy,
          isActive: this.ticketStatus == 2,
        })
      }

      this.internalNoteScheduled.forEach(note => {
        logs.push({
          type: 'internal_note',
          time: new Date(note.time),
          displayTime: note.time,
          by: note.by,
          text: note.text,
          isActive: false,
        })
      })

      if (this.ticketStatus > 1 && this.repairScheduleTime && this.ticketStatus !== 99) {
        this.logResolution.forEach(item => {
          logs.push({
            type: 'rescheduled',
            time: new Date(item.time),
            displayTime: item.time,
            by: item.ids,
            text: item.text,
            isActive: this.ticketStatus == 2,
          })
        })
      }

      if (this.ticketStatus == 99 && this.canceledTime) {
        logs.push({
          type: 'canceled',
          time: new Date(this.canceledTime),
          displayTime: this.canceledTime,
          by: this.canceledBy,
          text: this.canceledNote,
          isActive: true,
        })
      }

      if (this.repairedTime && this.ticketStatus > 2 && this.ticketStatus !== 99) {
        logs.push({
          type: 'repaired',
          time: this.repairedDate,
          displayTime: this.repairedTime,
          by: this.asaniTechnicianName,
          text: this.repairedNote,
          isActive: this.ticketStatus == 3,
        })
      }

      if (this.ticketStatus > 3 && this.ticketStatus !== 99 && this.solvedTime) {
        logs.push({
          type: 'solved',
          time: new Date(this.solvedTime),
          displayTime: this.solvedTime,
          by: this.solvedBy,
          text: this.solvedNote,
          isActive: this.ticketStatus == 4,
        })
      }

      return logs.sort((a, b) => new Date(b.displayTime) - new Date(a.displayTime))
    }
  },
  methods: {
    onFilePicked(e, index) {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-primary ml-2",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });

        const files = e.target.files
        if (files[0] !== undefined) {
            var imgFileName = files[0].name
            var imgFile = files[0]
            if (imgFileName.lastIndexOf('.') <= 0) {
                return
            }
            const fr = new FileReader()
            fr.readAsDataURL(files[0])
            fr.addEventListener('load', () => {
                var imgBase64 = fr.result.split("base64,")[1]
                if (imgFileName.toLowerCase().includes(".png") || imgFileName.toLowerCase().includes(".jpg") || imgFileName.toLowerCase().includes(".jpeg")) {
                    if (imgFile.size >= 5000000) {
                        imgFileName = ''
                        imgFile = ''
                        swalWithBootstrapButtons.fire({
                            title: "Maximum size is 5MB",
                            text: "",
                            icon: "warning",
                        })
                    }else{
                        this.reopenAttachment[index].fileName = imgFileName !== null ? imgFileName.replace(this.spaceRegex, ' ') : imgFileName
                        this.reopenAttachment[index].fileBase64 = imgBase64
                    }
                } else {
                    swalWithBootstrapButtons.fire({
                        title: "Photo only allows file types of PNG/JPG/JPEG.",
                        text: "",
                        icon: "warning",
                    })
                }
            })
        } else {
            this.reopenAttachment[index].fileName = 'Choose file...'
            this.reopenAttachment[index].fileBase64 = ''
        }
    },
    deleteAttachment(index){
        this.reopenAttachment[index].fileName = 'Choose file...'
        this.reopenAttachment[index].fileBase64 = ''
    },
    setReopenChoose(data) {
      this.reopenChoose = data
    },
    handleChangeAttachmentView(action) {
      if(action == 'next') {
        this.attachmentViewedIdx += 1
        console.log(this.attachmentViewedIdx)
      }

      if(action == 'prev') {
        this.attachmentViewedIdx -= 1
        console.log(this.attachmentViewedIdx)
      }

    },
    setTicketPuposeBadgeTheme() {
      this.ticketPurposeTheme = {
        bgColor : this.ticketPurpose == 'Kendala' ? '#FFE9EA' : '#FEF8E8',
        borderColor : this.ticketPurpose == 'Kendala' ? '#CC444A' : '#E8AC16',
      }
    },
    setTicketActionBoxTheme() {
      if(this.ticketStatus == 0) {
        this.ticketActionBoxTheme = 'col-12 shadow-sm ticket-action-box-confirm'
        this.ticketActionBoxText = {title : 'Konfirmasi tiket ?', description : 'Konfirmasi tiket agar dapat diteruskan ke tim IT Support. Pastikan kembali informasi perusahaan dan produk sudah benar.'}
      } else if (this.ticketStatus > 0 && this.ticketStatus < 3 && this.ticketPurpose == 'Kendala' && this.cancelResolution) {
        this.ticketActionBoxTheme = 'col-12 shadow-sm ticket-action-box-cancel'
        this.ticketActionBoxText = {title : 'Cancel tiket ?', description : 'Batalkan tiket jika kendala sudah teratasi. Tiket yang sudah dicancel tidak diteruskan ke IT Support untuk penanganan lebih lanjut.' }
      } else if (this.ticketStatus == 3) {
        this.ticketActionBoxTheme = 'col-12 shadow-sm ticket-action-box-reopen'
        this.ticketActionBoxText = {title : 'Reopen tiket ?', description : 'Jika produk masih bermasalah, tiket dapat dibuka kembali dengan masa tunggu 1 hari dari status ‘Repaired’.'}
      }
    },
    submitSwitchUnit() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.loadingButtonProcess = true
      this.$http.post(process.env.SUBMIT_CHANGE_TICKET_UNIT, {
          orderDetailsId: this.selectSwitchUnit.orderDetailsId,
          ticketId: this.ticketId
        }, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(res => {
          if (res.data.status == 200) {
            swalWithBootstrapButtons.fire({
              title: "Success",
              text: 'Success change unit.',
              icon: "success",
            })
            // location.reload()
            this.loadingButtonProcess = false
            this.getData()
            this.getSwitchUnitList()
            $('#modalChangeUnit').modal('hide')
          } else if (res.data.status == 201) {
            swalWithBootstrapButtons.fire({
              title: "Error",
              text: 'Failed to change Unit',
              icon: "error",
            })
            this.loadingButtonProcess = false
          }
        })
        .catch(error => {
          this.loadingButtonProcess = false
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: error.response.data.message,
            icon: "error",
          }).then(() => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getSwitchUnitList() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.selectSwitchUnit = { orderDetailsId: '', uniqueId: 'None' }
      this.switchUnitList = [{ orderDetailsId: '', uniqueId: 'None' }]
      this.$http.get(process.env.GET_PRODUCT_CODE_RENTING + this.ticketId, { headers: { 'Asani-Token': localStorage.getItem('jwt') } })
        .then(res => {
          console.log(res)
          res.data.content.forEach(el => {
            this.switchUnitList.push(el)
          })

        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: error.response.data.message,
            icon: "error",
          }).then(() => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    closeModal() {
      $('#modalReopenCase').modal('hide')
    },
    submitReopenTicket(caseResult) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      if (caseResult == 'new problem' && (this.problemSubmit == '' || this.problemSubmit == null)) {
        this.fieldProblemError = true

        return
      } else if(caseResult == 'new problem' && (this.reopenClientAddress == '' || this.reopenClientAddress == null)) {
        this.fieldReopenClientAddressError = true

        return
      }else {
        const self = this
        this.loadingButtonProcess = true
        this.loadingButtonSolved = true
        this.$http.post(process.env.REOPEN_CASE, {
            ticketId: Number(this.ticketId),
            problem: this.problemSubmit !== null ? this.problemSubmit.replace(this.spaceRegex, ' ') : this.problemSubmit,
            caseId: this.caseChoose,
            caseResult: caseResult,
            caseIdProblem: this.caseIdProblem,
            reopenChoose: this.reopenChoose.case,
            deviceStatus: this.deviceStatusChoose,
            productType: this.productType,
            note : this.reopenNote !== null ? this.reopenNote.replace(this.spaceRegex, ' ') : this.reopenNote,
            picAddress : this.reopenClientAddress ? this.reopenClientAddress.replace(this.spaceRegex, ' ') : this.reopenClientAddress,
            attachment : this.reopenAttachment
          }, {
            headers: { 'Asani-Token': localStorage.getItem('jwt') }
          })
          .then(response => {
            if (response.data.status == 400) {
              swalWithBootstrapButtons.fire({
                title: "Sorry",
                text: response.data.message,
                icon: "error",
              })

              $('#modalReopenCase').modal('hide')
            } else if (response.data.status == 200) {
              swalWithBootstrapButtons.fire({
                title: "Success",
                text: response.data.message,
                icon: "success",
              })
              this.loadingButtonProcess = false
              this.loadingButtonSolved = false
              $('#modalReopenCase').modal('hide')
              this.getData()
            } else if (response.data.status == 201) {
              swalWithBootstrapButtons.fire({
                title: "Sorry",
                text: "Ticket has been reopened to " + response.data.message,
                icon: "error",
              })
              $('#modalReopenCase').modal('hide')
              this.getData()
            }
          })
          .catch(error => {
            self.loadingButtonProcess = false
            self.loadingButtonSolved = false
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: error.response.data.message,
              icon: "error",
            }).then(() => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      }
    },
    getCaseKnowledge(id, solution, deviceStatus, idBefore, action) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      let api = true
      if (action == 'back' && this.idBefore.length == 1 && this.idBefore[0] == null) {
        id = this.idBefore[this.idBefore.length - 1]
        this.idBefore.pop()
        api = false
        this.caseKnowledgeShow = false
      } else if (action == 'back' && this.idBefore.length > 1) {
        id = this.idBefore[this.idBefore.length - 1]
        this.idBefore.pop()
      } else {
        this.idBefore.push(idBefore)
      }
      if (api) {
        this.loadingCase = true
        if (action == 'next') {
          this.loadingButtonNext = true
        } else if (action == 'still') {
          this.loadingButtonStill = true
        } else if (action == 'solved') {
          this.loadingButtonSolved = true
        } else if (action == 'back') {
          this.loadingButtonBack = true
        }
        // this.loadingButtonProcess = true
        this.$http.post(process.env.GET_CASE_KNOWLEDGE, {
            productType: this.productType,
            id: id
          }, {
            headers: { 'Asani-Token': localStorage.getItem('jwt') }
          })
          .then(response => {
            this.caseKnowledge = response.data.content[0].caseKnowledge
            this.loadingButtonNext = false
            this.loadingButtonStill = false
            this.loadingButtonSolved = false
            // this.loadingButtonProcess= false
            this.caseKnowledgeShow = true
            this.loadingButtonBack = false
            this.loadingButtonNext = false
            this.loadingCase = false
            this.isSolution = false
            this.endOfCase = false
            if (this.caseKnowledge.length == 1 && this.caseKnowledge[0].solution == 1) {
              if (this.caseIdProblem == null) {
                this.caseIdProblem = id
              }
              this.caseChoose = this.caseKnowledge[0].id
              this.isSolution = true
              this.caseInfo = this.caseKnowledge[0].info
              this.deviceStatusChoose = this.caseKnowledge[0].deviceStatus
            } else if (this.caseKnowledge.length == 0) {
              this.endOfCase = true
              this.caseChoose = id
              this.deviceStatusChoose = deviceStatus
            }

            if (action == 'back' && this.caseKnowledge[0].solution == 0) {
              this.caseIdProblem = null
            }

            if (action == 'back' && this.idBefore.length == 1 && this.idBefore[0] == null) {
              this.caseKnowledgeShow = false
            }
          })
          .catch(error => {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: error.response.data.message,
              icon: "error",
            }).then(() => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      }
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    toPhoneFormat(phoneNumber) {
      if (phoneNumber.length == 2 && phoneNumber == '08') {
        this.clientPicPhoneSubmit = '628'
      }
    },
    getRepairName(repairType) {
      let repairName = null
      if (repairType == 0) {
        repairName = 'Visit'
      } else if (repairType == 1) {
        repairName = 'Remote'
      }

      return repairName
    },
    formatDate(dateInput, time) {
      let dateFormat = null
      if (time == 'onlyDate') {
        if (this.repairSchedule != null) {
          let array = this.repairSchedule.split("-")
          dateFormat = array[2] + '-' + array[1] + '-' + array[0]
        }
      } else if (time = 'time') {
        if (dateInput != null) {
          let array1 = dateInput.split(" ")
          let array = array1[0].split("-")
          dateFormat = array[2] + '-' + array[1] + '-' + array[0]
          dateFormat = dateFormat + ' ' + array1[1]
        }
      }
      return dateFormat
    },
    resetModalValue() {
      // modal state reset
      this.caseKnowledgeShow = false
      this.caseChoose=null
      this.caseIdProblem=null
      this.reopenChoose = {
        case: null,
        reopenText: 'Select One'
      },
      this.problemSubmit = ''
      this.reopenNote = ''
      this.reopenClientAddress=''
      this.reopenAttachment = [
        {
          fileName:'Choose file...',
          fileBase64:''
        },
        {
          fileName:'Choose file...',
          fileBase64:''
        },
        {
          fileName:'Choose file...',
          fileBase64:''
        }
      ]

      this.confirmedNoteSubmit = null

      //ticketInfo
      this.clientPicSubmit = this.clientPic
      this.clientPicPhoneSubmit = this.clientPicPhone
      this.clientPicAddressSubmit = this.clientAddress
      this.asaniPicChoose = {
        id: this.asaniPicId,
        employeeName: this.asaniPic
      }
      this.fieldAsaniPICError = false
      this.$v.validationTicketInfo.$reset()

      //repairInfo
      this.asaniTechnician = {
        id: this.asaniTechnicianId,
        employeeName: this.asaniTechnicianName
      }
      this.repairScheduleSubmit = this.formatDate(null, 'onlyDate')
      this.repairTypeSubmit = {
        type: this.repairType,
        repairName: this.getRepairName(this.repairType)
      }

      // Cancel Ticket 
      this.cancelTicketReason = null

      this.deviceStatusChoose = this.deviceStatus
      this.loadingButtonProcess = false
      this.loadingButtonSolved = false

      // view attachment
      this.attachmentViewedIdx = 0
    },
    validateSelf(fieldName) {
      if (fieldName == 'confirm') {
        if (this.confirmedNoteSubmit.length == 0) {
          this.fieldConfirmError = true
        } else {
          this.fieldConfirmError = false
        }
      } else if (fieldName == 'asaniPicChoose') {
        this.fieldAsaniPICError = false
      } else if (fieldName == 'problem') {
        if(!this.problemSubmit) {
          this.fieldProblemError = true
        } else {
          this.fieldProblemError = false
        }

      } else if(this.fieldName == 'clientAddress'){
        if(!this.reopenClientAddress) {
          this.fieldReopenClientAddressError = true
        } else {
          this.fieldReopenClientAddressError = false
        }
      } else if (fieldName == 'repairSchedule') {
        if (this.repairScheduleSubmit != '') {
          this.fieldRepairScheduleError = false
        } else {
          this.fieldRepairScheduleError = true
        }
      } else if (fieldName == 'cancel') {
        if (this.cancelTicketReason.length == 0) {
          this.fieldCancelError = true
        } else if (this.cancelTicketReason.length > 250) {
          this.fieldCancelError = true
        } else {
          this.fieldCancelError = false
        }
      }
    },
    submitConfirm() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.fieldClientConfirmError = false
      this.fieldConfirmError = false
      if ( !this.selectedClientConfirmationNote.confirmationNote) {
        this.fieldClientConfirmError = true
      } else if ((this.selectedClientConfirmationNote.confirmationNote == 'Lainnya' &&  !this.confirmedNoteSubmit)) {
        this.fieldConfirmError = true
      } else {
        this.loadingButtonProcess = true
        this.$http.post(process.env.CONFIRM_TICKET, {
            ticketId: this.ticketId,
            reportToUser : this.selectedClientConfirmationNote.confirmationNote,
            note: this.confirmedNoteSubmit ? this.confirmedNoteSubmit.replace(this.spaceRegex,' ') : this.confirmedNoteSubmit
          }, {
            headers: { 'Asani-Token': localStorage.getItem('jwt') }
          })
          .then(response => {
            if (response.data.status == 400) {
              swalWithBootstrapButtons.fire({
                title: "Sorry",
                text: response.data.message,
                icon: "error",
              })
              $('#modalConfirm').modal('hide')
            } else if (response.data.status == 200) {
              swalWithBootstrapButtons.fire({
                title: "Success",
                text: response.data.message,
                icon: "success",
              })
              // this.sendLog(this.ticketId, 36)
              this.loadingButtonProcess = false
              $('#modalConfirm').modal('hide')
              this.getData()
            }
          })
          .catch(error => {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: error.response.data.message,
              icon: "error",
            }).then(() => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      }
    },
    cancelTicket() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      if (this.cancelTicketReason == null || this.cancelTicketReason.trim() == '') {
        this.fieldCancelError = true
        return
      } else if(this.cancelTicketReason.length > 250) {
        this.fieldCancelError = true
        return
      } else {
        const self = this
        this.loadingButtonProcess = true
        this.$http.post(process.env.CANCEL_TICKET, {
            ticketId: Number(this.ticketId),
            reasonCancelation: this.cancelTicketReason.replace(this.spaceRegex, ' ')
          }, {
            headers: { 'Asani-Token': localStorage.getItem('jwt') }
          })
          .then(response => {
            if (response.data.status == 400) {
              swalWithBootstrapButtons.fire({
                title: "Sorry",
                text: response.data.message,
                icon: "error",
              })
              $('#modalCancel').modal('hide')
            } else if (response.data.status == 200) {
              swalWithBootstrapButtons.fire({
                title: "Success",
                text: response.data.message,
                icon: "success",
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload()
                }
              })
              // this.sendLog(this.ticketId, 36)
              this.loadingButtonProcess = false
              $('#modalCancel').modal('hide')
              this.getData()
            }
          })
          .catch(error => {
            self.loadingButtonProcess = false
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: error.response.data.message,
              icon: "error",
            }).then(() => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      }
    },
    cekField(nameCheck) {
      let error = 0
      if (nameCheck == 'ticket') {
        this.$v.validationTicketInfo.$touch()
        if (this.asaniPicChoose == '') {
          error++
          this.fieldAsaniPICError = true
        }
        if (this.$v.validationTicketInfo.$invalid) {
          error++
        }
      } else if (nameCheck == 'repair') {
        if (this.asaniTechnician.id == null) {
          error++
          this.fieldAsaniTechnicianError = true
        } else if (this.repairScheduleSubmit == null || this.repairScheduleSubmit == '') {
          error++
          this.fieldRepairScheduleError = true
        } else if (this.repairTypeSubmit.type == null) {
          error++
          this.fieldRepairTypeError = true
        }
      }
      return error
    },
    submitEditRepairInfo() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      if (this.cekField('repair') == 0) {
        this.loadingButtonProcess = true
        this.$http.post(process.env.CHANGE_REPAIR_INFO, {
            ticketId: this.ticketId,
            technicianId: this.asaniTechnician.id,
            repairSchedule: this.repairScheduleSubmit,
            repairType: this.repairTypeSubmit.type
          }, {
            headers: { 'Asani-Token': localStorage.getItem('jwt') }
          })
          .then(response => {
            if (response.data.status == 400) {
              swalWithBootstrapButtons.fire({
                title: "Sorry",
                text: response.data.message,
                icon: "error",
              })
              $('#modalRepairInfo').modal('hide')
            } else if (response.data.status == 200) {
              swalWithBootstrapButtons.fire({
                title: "Success",
                text: response.data.message,
                icon: "success",
              })
              // this.sendLog(this.ticketId, 38)
              this.loadingButtonProcess = false
              $('#modalRepairInfo').modal('hide')
              this.getData()
            }
          })
          .catch(error => {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: error.response.data.message,
              icon: "error",
            }).then(() => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      }
    },
    submitEditTicketInfo() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      if (this.cekField('ticket') == 0) {
        this.loadingButtonProcess = true
        this.$http.post(`${process.env.CHANGE_TICKET_INFO}/${this.ticketId}/change-ticket-info`, {
            // ticketId: this.ticketId,
            asaniPic: this.asaniPicChoose.id,
            clienName: this.clientPicSubmit !== null ? this.clientPicSubmit.replace(this.spaceRegex, ' ') : this.clientPicSubmit,
            clientPhone: this.clientPicPhoneSubmit,
            clientAddress : this.clientPicAddressSubmit !== null ? this.clientPicAddressSubmit.replace(this.spaceRegex, ' ') : this.clientPicAddressSubmit
          }, {
            headers: { 'Asani-Token': localStorage.getItem('jwt') }
          })
          .then(response => {
            if (response.data.status == 400) {
              swalWithBootstrapButtons.fire({
                title: "Sorry",
                text: response.data.message,
                icon: "error",
              })
              $('#modalTicketInfo').modal('hide')
            } else if (response.data.status == 200) {
              swalWithBootstrapButtons.fire({
                title: "Success",
                text: response.data.message,
                icon: "success",
              })
              // this.sendLog(this.ticketId, 38)
              this.loadingButtonProcess = false
              $('#modalTicketInfo').modal('hide')
              this.getData()
            }
          })
          .catch(error => {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: error.response.data.message,
              icon: "error",
            }).then(() => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      }
    },
    getToday() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var date = yyyy + '-' + mm + '-' + dd
      this.todayDate = date
    },
    // parsingProduct(){
    //   if (this.productType == 1 || this.productType == 2) {
    //     this.productBrand = JSON.parse(this.productSpec).brand 
    //     this.productModel = JSON.parse(this.productSpec).model 
    //     this.productVarian = JSON.parse(this.productSpec).processor+'/'+JSON.parse(this.productSpec).ram+'GB/'+JSON.parse(this.productSpec).storage+'/'+JSON.parse(this.productSpec).vga
    //     this.productScreen = JSON.parse(this.productSpec).screen+' Inch' 
    //     this.productProcessor = JSON.parse(this.productSpec).processor 
    //     this.productVGA = JSON.parse(this.productSpec).vga 
    //     this.productRAM = JSON.parse(this.productSpec).ram+' GB' 
    //     this.productStorage = JSON.parse(this.productSpec).storage 
    //   }else if (this.productType == 3) {
    //     this.productBrand = JSON.parse(this.productSpec).brand 
    //     this.productModel = JSON.parse(this.productSpec).model 
    //     this.productVarian = JSON.parse(this.productSpec).displaySize+' Inch/'+JSON.parse(this.productSpec).displayType
    //     this.displayType = JSON.parse(this.productSpec).displayType
    //     this.productScreen = JSON.parse(this.productSpec).displaySize+' Inch' 
    //     this.portVGA = JSON.parse(this.productSpec).portVga
    //     this.portDvid = JSON.parse(this.productSpec).portDvid
    //     this.portHdmi = JSON.parse(this.productSpec).portHdmi
    //   }else if (this.productType == 4) {
    //     this.productBrand = JSON.parse(this.productSpec).brand 
    //     this.productModel = JSON.parse(this.productSpec).model
    //     this.colorTech = JSON.parse(this.productSpec).colorTech
    //     this.feature = JSON.parse(this.productSpec).feature
    //   } else if (this.productType == 5 || this.productType == 6) {
    //     this.productBrand = JSON.parse(this.productSpec).brand 
    //     this.productModel = JSON.parse(this.productSpec).model 
    //     this.productVarian = JSON.parse(this.productSpec).processor+'/'+JSON.parse(this.productSpec).ram+'GB/'+JSON.parse(this.productSpec).storage
    //     this.productScreen = JSON.parse(this.productSpec).screen+' Inch' 
    //     this.productProcessor = JSON.parse(this.productSpec).processor 
    //     this.productRAM = JSON.parse(this.productSpec).ram+' GB' 
    //     this.productStorage = JSON.parse(this.productSpec).storage 
    //   }else if (this.productType >= 7) {
    //     this.productBrand = JSON.parse(this.productSpec).brand 
    //     this.productModel = JSON.parse(this.productSpec).model 
    //     this.productVarian = JSON.parse(this.productSpec).model
    //   }
    // },
    openModal(modalName) {
      this.resetModalValue()
      $("#modal" + modalName).modal('show')
    },
    openModalDar() {
      $("#modalFormDar").modal('show')
    },
    openModalViewDar() {
      $("#modalViewDar").modal('show')
    },
    handleEditFromViewDar() {
      this.openModalDar()
    },
    handleDarSaveDraft() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      $("#modalFormDar").modal('hide')
      swalWithBootstrapButtons.fire({
        title: "Berhasil",
        text: "Dokumen DAR (Damage Analysis Report) telah berhasil disimpan sebagai Draft.",
        icon: "success",
        confirmButtonText: "Ok",
      })
      this.getDarDetail()
    },
    handleDarSubmit() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      $("#modalFormDar").modal('hide')
      swalWithBootstrapButtons.fire({
        title: "Berhasil",
        text: "Dokumen DAR (Damage Analysis Report) telah berhasil di submit.",
        icon: "success",
        confirmButtonText: "Selesai",
      })
      this.getDarDetail()
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: response.data.message,
            icon: "error",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: error.response.data.message,
            icon: "error",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true
        }
        if (this.permission[i] == '3.1') {
          this.viewReturn = true
        }
        if (this.permission[i] == '3.2') {
          this.editReturn = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
        }
        if (this.permission[i] == '4.2') {
          this.editProduct = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '5.2') {
          this.editPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '7.2') {
          this.editResolution = true
        }
        if (this.permission[i] == '7.3') {
          this.cancelResolution = true
        }
        if (this.permission[i] == '7.5') {
          this.allowViewDarDoc = true
        }
        if (this.permission[i] == '7.6') {
          this.allowEditDarDoc = true
        }
        if (this.permission[i] == '7.7') {
          this.allowCreateDarDoc = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '8.2') {
          this.editLessor = true
        }
        if (this.permission[i] == '9.2') {
          this.editLessee = true
        }
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewResolution == false) {
        this.$router.push('/')
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id) {
      window.open(this.$router.resolve('/resolution/detail/' + id).href, '_blank');
    },
    getData() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.loadingTable = true
      this.$http.get(`${process.env.DETAIL_COMPLAIN}/${this.ticketId}/detail-complain`, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          if (response.data.status == 400) {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: response.data.message,
              icon: "error",
            })
          } else {
            this.detailItem = response.data.data
            this.companyName = response.data.data.companyName
            this.companyId = response.data.data.companyId
            this.companyAddress = response.data.data.companyAddress
            this.ticketStatus = response.data.data.ticketStatus
            this.ticketPurpose = response.data.data.purpose
            this.ticketBastInfo = response.data.data.bastInfo
            // set ticket Conditional Theme
            this.setTicketActionBoxTheme()
            this.setTicketPuposeBadgeTheme()
            this.ticketNumber = response.data.data.ticketCode
            this.asaniPicId = response.data.data.picAsani
            this.asaniPic = response.data.data.picAsaniName
            this.clientPic = response.data.data.picName
            this.clientPicPhone = response.data.data.picPhone
            this.clientAddress = response.data.data.picAddress
            this.clientPicEmail = response.data.data.picEmail
            this.orderLessorId = response.data.data.orderLessorId
            this.orderLessorName = response.data.data.orderLessorName
            this.problemCategory = response.data.data.problemCategory
            this.repairSchedule = response.data.data.repairSchedule
            this.repairScheduleSubmit = this.formatDate(null, 'onlyDate')
            this.asaniTechnicianName = response.data.data.techName
            this.asaniTechnicianId = response.data.data.techId
            this.asaniTechnician = {
              id: response.data.data.techId,
              employeeName: response.data.data.techName
            }
            
            // For Product Information table Data
            if(response.data.data.newProduct) {
              this.orderIdReal = response.data.data.orderId
              this.orderId = response.data.data.newProduct.orderCode
              this.productCode = response.data.data.newProduct.productCode
              this.productName = response.data.data.newProduct.productName
              this.productTypeName = response.data.data.newProduct.productTypeName
              this.productType = response.data.data.newProduct.productType
              this.productModel = response.data.data.newProduct.model
              this.productSN = response.data.data.newProduct.sn
              const newSpec = JSON.parse(response.data.data.newProduct.productDetail)
              if(this.productType == 1 || this.productType == 2 ) {
                this.productSpecView = `${newSpec.processor}/${newSpec.ram}GB/${newSpec.storage}/${newSpec.vga}`
              }
              this.windowsLicense = response.data.data.newProduct.windowsLicense
              if (response.data.data.newProduct.windowsLicense == '' | response.data.data.newProduct.windowsLicense == null) {
                this.windowsLicense = '-'
              }
              this.officeLicense = response.data.data.newProduct.officeLicense
              if (response.data.data.officeLicense == '' | response.data.data.officeLicense == null) {
                this.officeLicense = '-'
              }
              this.productCondition = response.data.data.newProduct.condition
              this.endRent = response.data.data.newProduct.endRent
              this.bomItems = response.data.data.newProduct.bomItem
              this.actualSpec = response.data.data.newProduct.actual

              // Product Sebelumnya
              this.oldOrderId = response.data.data.oldProduct.orderCode
              this.oldProductCode = response.data.data.oldProduct.productCode
              this.oldProductName = response.data.data.oldProduct.productName
              this.oldProductTypeName = response.data.data.oldProduct.productTypeName
              this.oldProductType = response.data.data.oldProduct.productType
              this.oldProductModel = response.data.data.oldProduct.model
              this.oldProductSN = response.data.data.oldProduct.sn
              
              const oldSpec = JSON.parse(response.data.data.oldProduct.productDetail)
              if(this.productType == 1 || this.productType == 2 ) {
                this.oldProductSpecView = `${oldSpec.processor}/${oldSpec.ram}GB/${oldSpec.storage}/${oldSpec.vga}`
              }
              this.oldWindowsLicense = response.data.data.oldProduct.windowsLicense
              if (response.data.data.oldProduct.windowsLicense == '' | response.data.data.oldProduct.windowsLicense == null) {
                this.oldWindowsLicense = '-'
              }
              this.oldOfficeLicense = response.data.data.oldProduct.officeLicense
              if (response.data.data.oldProduct.officeLicense == '' | response.data.data.oldProduct.officeLicense == null) {
                this.oldOfficeLicense = '-'
              }
              this.oldProductCondition = response.data.data.oldProduct.condition
              this.oldEndRent = response.data.data.oldProduct.endRent
              this.oldBomItems = response.data.data.oldProduct.bomItem
              this.oldActualSpec = response.data.data.oldProduct.actual
            } else {
              this.orderIdReal = response.data.data.orderId
              this.orderId = response.data.data.oldProduct.orderCode
              this.productCode = response.data.data.oldProduct.productCode
              this.productName = response.data.data.oldProduct.productName
              this.productTypeName = response.data.data.oldProduct.productTypeName
              this.productType = response.data.data.oldProduct.productType
              this.productModel = response.data.data.oldProduct.model
              this.productSN = response.data.data.oldProduct.sn
              const newSpec = JSON.parse(response.data.data.oldProduct.productDetail)
              if(this.productType == 1 || this.productType == 2 ) {
                this.productSpecView = `${newSpec.processor}/${newSpec.ram}GB/${newSpec.storage}/${newSpec.vga}`
              }
              this.windowsLicense = response.data.data.oldProduct.windowsLicense ? response.data.data.oldProduct.windowsLicense : '-'

              this.officeLicense = response.data.data.oldProduct.officeLicense ? response.data.data.oldProduct.officeLicense : '-'
            
              this.productCondition = response.data.data.oldProduct.condition
              this.endRent = response.data.data.oldProduct.endRent
              this.bomItems = response.data.data.oldProduct.bomItem
              this.actualSpec = response.data.data.oldProduct.actual
            }
            // End OF Product Infromation Data

            this.productVarian = response.data.data.productVarian
            this.historyDevices = response.data.data.historyDevices


            this.createBy = response.data.data.createBy
            this.createTime = response.data.data.createTime
            this.problem = response.data.data.problem
            this.attachment = []
            if (response.data.data.attch1 != null && response.data.data.attch1 != '') {
              this.attachment.push(response.data.data.attch1)
            }
            if (response.data.data.attch2 != null && response.data.data.attch2 != '') {
              this.attachment.push(response.data.data.attch2)
            }
            if (response.data.data.attch3 != null &&response.data.data.attch3 != '') {
              this.attachment.push(response.data.data.attch3)
            }
            this.ticketNote =response.data.data.note
            this.specialRequest = response.data.data.specialRequest

            this.confirmedNote =response.data.data.confirmedNote
            this.confirmedBy =response.data.data.confirmedBy
            this.confirmedTime =response.data.data.confirmedTime

            this.canceledNote =response.data.data.cancelReason
            this.canceledBy =response.data.data.cancelBy
            this.canceledTime =response.data.data.cancelDate


            this.repairScheduleBy =response.data.data.repairScheduleBy
            this.repairScheduleTime =response.data.data.repairScheduleTime
            this.repairType =response.data.data.repairType
            this.repairTypeSubmit = {
              type: response.data.data.repairType,
              repairName: this.getRepairName(response.data.data.repairType)
            }

            this.asaniPicChoose = {
              id: response.data.data.picAsani,
              employeeName: response.data.data.picAsaniName
            }

            this.clientPicSubmit = response.data.data.picName !== null ? response.data.data.picName.replace(this.spaceRegex, ' ') : response.data.data.picName
            this.clientPicPhoneSubmit = response.data.data.picPhone

            this.repairedNote = response.data.data.repairedNote !== null ? response.data.data.repairedNote.replace(this.spaceRegex, ' ') : response.data.data.repairedNote
            this.repairedTime = response.data.data.repairedTime
            this.repairedDate = response.data.data.repairedDate ? response.data.data.repairedDate : response.data.data.repairedTime

            this.solvedNote = response.data.data.solvedNote !== null ? response.data.data.solvedNote.replace(this.spaceRegex, ' ') : response.data.data.solvedNote
            this.solvedTime = response.data.data.solvedTime
            this.solvedBy = response.data.data.solvedBy
            this.deviceStatus = response.data.data.deviceStatus
            this.deviceStatusChoose = response.data.data.deviceStatus

            this.internalNoteScheduled = []
            this.internalNoteConfirmed = []
            this.internalNoteCreated = []
            this.internalNotes = response.data.data.internalNotes !== null ? response.data.data.internalNotes.replace(this.spaceRegex, ' ') : response.data.data.internalNotes
              let repairs = new Date(this.formatDate(this.repairScheduleTime))
              let conf = new Date(this.formatDate(this.confirmedTime))
              let crea = new Date(this.formatDate(this.createTime))
            for (var i = 0; i < this.internalNotes.length; i++) {
              let notedate = new Date(this.internalNotes[i].time)
              if (notedate > repairs) {
                this.internalNoteScheduled.push({
                  by: this.internalNotes[i]["by"],
                  text: this.internalNotes[i]["text"],
                  time: notedate
                })
              } else if (notedate > conf) {
                this.internalNoteConfirmed.push({
                  by: this.internalNotes[i]["by"],
                  text: this.internalNotes[i]["text"],
                  time: notedate
                })
              } else if (notedate > crea) {
                this.internalNoteCreated.push({
                  by: this.internalNotes[i]["by"],
                  text: this.internalNotes[i]["text"],
                  time: notedate
                })
              }
            }
            this.loadingTable = false
            // this.parsingProduct()
            this.getToday()
          }
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: error.response.data.message,
            icon: "error",
          }).then(() => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })

      this.$http.get(process.env.GET_ALL_EMPLOYEE, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          if (response.data.status == 200) {
            this.asaniPicSelect = response.data.content
          }
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: error.response.data.message,
            icon: "error",
          }).then(() => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    sendLog(x, y) {
      var today = new Date();
      var month = today.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var dateDay = today.getDate()
      if (dateDay < 10) {
        dateDay = '0' + dateDay
      }
      var hours = today.getHours()
      if (hours < 10) {
        hours = '0' + hours
      }
      var minutes = today.getMinutes()
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      var second = today.getSeconds()
      if (second < 10) {
        second = '0' + second
      }
      var date = today.getFullYear() + '-' + month + '-' + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + ' ' + time;
      var admin = this.admin
      var command = 'add-logs'
      var productName = this.productNameChoose

      this.$http.post(process.env.LOG_URL + "/ticket/" + x, {
          codeLogs: y,
          params: [],
        }, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          this.connectLogResolution()
        })
        .catch(error => {
          console.log(error)
        })
    },
    connectLogResolution: function () {
      var ticketId = this.ticketId
      this.$http.get(process.env.LOG_URL + "/ticket/" + ticketId, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          if (response.data.status === 200) {
            this.logResolution = response.data.content

            this.logResolution = this.logResolution.filter(item => item.text.toLowerCase().includes("jadwal kunjungan"))
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getAiChatHistory () {
       const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

       this.$http.get(`${process.env.GET_AI_CHAT_HISTORY}/${this.ticketId}/new/caseknowledge/history`, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          this.chatHistData = response.data.data
        }).catch(error => {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: error.response.data.message,
            icon: "error",
          }).then(() => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getTicketConfirmationNoteOptions() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.$http.get(process.env.GET_CONFIRMATION_NOTE_OPTIONS, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          // this.clientConfirmationNoteOptions = []
          let noteOptions = []
          if (response.data.status == 200) {
            if(response.data.data.length > 0) {
              response.data.data.forEach((item, index) => {
                noteOptions.push({
                  id : index,
                  confirmationNote : item
                })
              })
            }
          }
          this.clientConfirmationNoteOptions = [...noteOptions]
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: error.response.data.message,
            icon: "error",
          }).then(() => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    downloadBast () {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.loadingDownloadTicketBast = true
      this.$http.get(
        process.env.DOWNLOAD_TICKET_BAST + this.ticketId + '/bast/download',
        {
          timeout: 30 * 1000,
          responseType: "arraybuffer",
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(res => {
          if (res.data.status == 400) {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: res.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
          this.forceFileDownload(res,"ticketBast_" + this.ticketNumber + ".pdf");
          this.loadingDownloadTicketBast = false
        })
        .catch(error => {
          this.loadingDownloadTicketBast = false
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: error.response.data.message,
            icon: "error",
          }).then(() => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getDarDetail() {
      this.$http.get(`${process.env.GET_DAR_DETAIL}/${this.ticketId}/detail`, {
        headers: { 'Asani-Token': localStorage.getItem('jwt') }
      })
      .then(response => {
        if (response.data.status === 200 && response.data.data) {
          this.darDetailData = response.data.data
        }
      })
      .catch(() => {})
    },
    downloadDarDoc() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.loadingDownloadDar = true
      this.$http.post(
        `${process.env.DOWNLOAD_DAR_DOC}`,
        {
          Id: this.darDetailData ? this.darDetailData.id : null,
          ticketId: Number(this.ticketId),
        },
        {
          timeout: 30 * 1000,
          responseType: "arraybuffer",
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(res => {
          this.forceFileDownload(res, "DAR_" + this.ticketNumber + ".pdf");
          this.loadingDownloadDar = false
        })
        .catch(error => {
          this.loadingDownloadDar = false
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message,
            icon: "error",
          }).then(() => {
            if(error.response && error.response.data && error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
  },
  watch : {
    activeLog : function (val) {
        console.log(val)
      }
  },
  created() {
    this.ticketId = this.$route.params.ticketId
    this.admin = localStorage.getItem('admin_name')
    this.cekLogin()
    this.cekPermission()
    this.getData()
    this.getAiChatHistory()
    this.getSwitchUnitList()
    this.connectLogResolution()
    this.getTicketConfirmationNoteOptions()
    this.getDarDetail()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.product-label-row {
  min-height: 34px; /* sama dengan tinggi badge */
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.badge-success {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: #15803D;
    background: #F0FDF4;
    border: 1px solid #86EFAC;
  }
.badge-warning {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: #B45309;
    background: #FFFBEB;
    border: 1px solid #FCD34D;
  }

.dot {
  height:18px;
  width: 18px;
  border-radius: 50%;
  display: inline-block;
}

.item-badge {
  display: inline-block;
  padding: 0.4em 0.6em;
  font-size: 75%;
  font-weight: 550;
  line-height: 18px;
  letter-spacing: 0.005em;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1rem;
  border : 1.5px solid;
  color: #2E3646;
}

.ticket-info-table td:first-child {
  padding-right: 6px;
  white-space: nowrap;
}

.ticket-info-table td:nth-child(2) {
  padding-right: 6px;
}

.status-badge {
  display: inline-block;
  padding: 0.3em 0.8em;
  font-size: 12px;
  font-weight: 500;
  border-radius: 1rem;
}

.case-knowledge:hover {
  cursor: pointer;
  background-color: #2797FB;
  color: white;
}

.scroll {
  max-height: 200px;
  overflow-y: auto;
}

.darker {
  border-color: #ccc;
  background-color: #ddd;
}

.img-responsive {
  max-width: 80px;
  height: auto;
  margin: 5px;
}

.img-responsive:hover {
  cursor: pointer;
}

.history-title {
  font-weight: bold;
}

.ticket-note {
  color: #f57f6c;
  font-style: italic;
}

.ticket-action-box {
  border-radius: 0.5rem;
}

.title-square-background {
  background-color: #F8F9FB;
}

.ticket-action-box-confirm {
  border-radius: 0.5rem;
  background-color: #F1F7FE;
  border: 2px solid;
  border-color: #5A9AE8;
}

.ticket-action-box-cancel {
  border-radius: 0.5rem;
  background-color: #FFE9EA;
  border: 2px solid;
  border-color: #CC444A;
}

.ticket-action-box-reopen {
  border-radius: 0.5rem;
  background-color: #FEF8E8;
  border: 2px solid;
  border-color : #E8AC16;
}

.title-square {
  font-weight: 700;
  font-size: 14pt;
  font-style: normal;
  letter-spacing: 0.0015em;
  color: #2E3646;
}

.title-product-info {
  font-weight: 700;
  font-size: 10pt;
  font-style: normal;
  letter-spacing: 0.0015em;
  color: #2E3646;
}

.link-blue {
  text-decoration: underline;
  color: blue;
  font-style: italic;
}

.link-blue:hover {
  cursor: pointer;
}

.label-addon-permonth {
  width: 122px;
  margin: 6px 0px;
}

.highlight-div {
  margin-top: -12px;
}

.highlight {
  font-style: italic;
  color: red;
  font-weight: bold;
  font-size: 65%;
}

.rp-total {
  margin-left: 0px;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.one-line .ol-label {
  width: 258px;
  margin: 2px 0px;
}

.one-line .ol-label-reason {
  width: 88px;
  margin: 2px 0px;
}

.one-line .ol-label-ram {
  width: 252px;
  margin: 2px 0px;
}

.one-line .ol-label-hardisk {
  width: 500px;
  margin: 2px 0px;
}

.one-line .ol-label-total-price {
  width: 148px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 199px;
  margin: 2px 0px;
}

.one-line .ol-label-partnership {
  width: 135px;
  margin: 2px 0px;
}

.one-line .ol-label-action {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.one-line .ol-titik2-select {
  width: 15px;
  margin: 2px 0px;
}

.label-log-act {
  margin-bottom: -24px;
}

.body-request {
  padding: 10px 10px;
  margin-left: 10px;
}

.request-value {
  margin-top: -21px;
}

.image-resolution {
  width: 100%;
  height: auto;
}

.fixed_header {
  table-layout: fixed;
  border-collapse: collapse;
}

.fixed_header tbody {
  display: block;
  overflow: auto;
  height: 180px;
  width: 100%;
}

.fixed_header tbody.full-width tr td {
  width: 100%;
}

.fixed_header thead tr {
  display: block;
}

.fixed_header th,
.fixed_header td {
  padding: 5px;
  text-align: left;
  width: 1578px;
  word-break: break-word;
  overflow-wrap: break-word;
}

.fixed-header {
  table-layout: fixed;
}

.fixed-header th,
.fixed-header td {
  word-break: break-word;
  overflow-wrap: break-word;
}

.fixed-header td:first-child {
  width: 160px;
}

.fixed_header tbody.full-width tr td {
  width: 1578px;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.pagg {
  display: inline-flex;
  overflow: auto;
}

.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}

.active {
  color: #2797FB;
}

.right-dropdown {
  margin-left: 7px;
}

.account-div {
  margin: 2px 2px;
}

.right-arrow {
  margin-left: auto;
}

.brand-logo {
  width: 120px;
}

.menu-title {
  margin-left: 1.125rem;
}

.menu-title-order {
  margin-left: 1.95rem;
}

.menu-title-payment {
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}

.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}

.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}

.nav-side-menu .toggle-btn {
  display: none;
}

.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}

.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}

.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}

.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}

.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}

.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}

.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}

.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

.chat-box-ai {
  border-radius: 0.3rem;
  background-color: #F1F7FE;
  border: 1px solid;
  border-color: #5582b5;
  max-width: 50%;
  padding: 0.5rem;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.16px;
}

.chat-box-user {
  background-color: '#FFFFFF';
  border-radius: 0.3rem;
  background-color: #FFFFFF;
  border: 1px solid;
  border-color: #5582b5;
  padding: 0.5rem;
  max-width: 50%;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.16px;
}


@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }

  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}

@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}

@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Resolution/ResolutionCenterDetailPage.vue